import React, { useEffect, useState, useRef } from 'react';
import './Professionalinfo.css';
import { Container, Button, Form, Row, Col, Card, Dropdown } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AgencyNavbar from "../../../Components/Pages/Navbar/AgencyNavbar";
import Swal from 'sweetalert2';
import { FaEye, FaChevronDown, FaSearch } from "react-icons/fa";
import BaseUrl from '../../../Components/ApiServices/BaseUrl';

// Import the component files
import TailorFields from './AgencyTailorFields';
import BeauticianFields from './AgencyBeauticianFields';
import TeacherFields from './AgencyTeacherFields';
import AgencyWelderFields from './AgencyWelderFields';
import AgencyFabricatorPipeFitterFields from './AgencyFabricatorPipeFitterFields';
import AgencyElectricianFields from './AgencyElectricianFields';
import AgencyACTechnicianFields from './AgencyACTechnicianFields';
import AgencyChillerTechnicianFields from './AgencyChillerTechnicianFields';
import AgencyLatheMachineFields from './AgencyLatheMachineFields';
import AgencyElevatorTechnicianFields from './AgencyElevatorTechnicianFields';
import {
  DOMESTIC_HELPER_POSITIONS,
  HOSPITALITY_CATEGORY,
  HOSPITALITY_EXPERIENCE_TYPES,
  HOSPITALITY_POSITIONS,
  PROFESSIONAL_INFO_CATEGORIES,
  SOFTWARE_IT_CATEGORY,
  SOFTWARE_IT_CERTIFICATIONS,
  SOFTWARE_IT_DATABASE_SKILLS,
  SOFTWARE_IT_FRAMEWORKS,
  SOFTWARE_IT_OTHER_SKILLS,
  SOFTWARE_IT_POSITIONS,
  SOFTWARE_IT_PROGRAMMING_LANGUAGES,
  CONSTRUCTION_CATEGORY,
  CONSTRUCTION_POSITIONS,
  RETAIL_SALES_CATEGORY,
  RETAIL_SALES_POSITIONS,
  CLEANING_MAINTENANCE_CATEGORY,
  CLEANING_MAINTENANCE_POSITIONS,
  SECURITY_CATEGORY,
  SECURITY_POSITIONS,
  OFFICE_STAFF_CATEGORY,
  OFFICE_STAFF_POSITIONS,
  DRIVER_CATEGORY,
  DRIVER_POSITIONS,
  HEALTHCARE_POSITIONS,
  filterCompanyWorkerPositions
} from '../../../Constants/dropdownOptions';

function Professionalinfo() {
  const navigate = useNavigate();
  const location = useLocation();
  const stateUserId = location.state?.userId || location.state?.userData?.user_id;
  const stateUserName = location.state?.userName || (location.state?.userData ? `${location.state.userData.first_name} ${location.state.userData.last_name}` : null);
  const localUser = JSON.parse(localStorage.getItem("user")) || {};

  const isCandidateFlow = !!stateUserId;
  const userId = isCandidateFlow ? stateUserId : (localUser.id || '');
  const userName = isCandidateFlow ? (stateUserName || '') : (localUser.first_name || '');
  const current_country = location.state?.current_country || '';
  const visaIssuedDateRef = useRef(null);
  const preferredStartDateRef = useRef(null);

  const [formData, setFormData] = useState({
    user_id: userId,
    category: 'Domestic Helper',
    job_position: [],
    other_position: '',
    is_ban: false,
    ban_reason: '',
    banned_country: '',
    job_type: 'Full Time',
    preferred_start_date: 'Immediate',
    current_work_status: 'Finished contract',
    visa_type: 'Looking for visa',
    visa_issued_date: null,
    visa_expiry_date: null,
    noc_or_transfer_letter: null,
    driving_license_country: ["Qatar", "Saudi"],
    other_driving_license_country: '',
    car_type: ["Manual", "Semi Automatic", "Fully Automatic"],
    previous_car: ["Land Cruiser", "Nissan Patrol", "Toyota Camry"],
    other_previous_car: '',
    hospitality_experience_types: [],
    // Nursing specific fields
    current_hospital_name: '',
    current_hospital_country: '',
    current_employment_date: null,
    current_finish_contract_date: null,
    previous_hospital_name: '',
    previous_hospital_country: '',
    previous_employment_date: null,
    previous_finish_contract_date: null,
    nursing_qualifications: ["Certificate in Nursing"],
    professional_qualifications: [],
    specialized_qualifications: [],
    language_qualifications: [],
    // Cultural adaptation fields
    has_prometric_certificate: null,
    prometric_issue_date: null,
    prometric_expiry_date: null,
    prometric_issued_country: '',
    has_dataflow_certificate: null,
    dataflow_issue_date: null,
    dataflow_expiry_date: null,
    dataflow_issued_country: '',
    cultural_adaptation_qualifications: [],
    software_it_programming_languages: [],
    software_it_frameworks: [],
    software_it_database_skills: [],
    software_it_other_skills: [],
    software_it_certifications: [],
    software_it_other_programming_language: '',
    software_it_other_certification: '',
    // New fields from image
    nursing_job_countries: ["Qatar"],
    language_skills: ["English"],
    nursing_license_countries: [],
    other_nursing_license_country: '',
    nursing_license_issue_date: null,
    nursing_license_expiry_date: null,
    has_nursing_license: true,
    no_of_children: '',
    nursing_positions: [],
    // Tailor specific fields
    tailor_mode: '',
    tailor_type: '',
    stitching_preferences: [],
    fabric_preference: [],
    style_preference: [],
    other_skills: [],
    // Beautician specific fields
    beautician_mode: '',
    beautician_type: '',
    henna_services: [],
    makeup_services: [],
    skin_care_services: [],
    nail_services: [],
    hair_services: [],
    massage_spa_services: [],
    other_trending_services: [],
    // Teacher specific fields
    teaching_mode: [],
    subjects: [],
    age_groups: [],
    classes: [],
    daily_hours: [],
    curriculum: [],
    special_skills: [],
    sports_games: [],
    sports_age_groups: [],
    training_mode: [],
    // CNC Programmer fields
    gulf_europe_experience: '',
    gulf_europe_countries: [],
    industry_experience: '',
    cnc_controls: [],
    cnc_machines: [],
    programming_type: '',
    cad_cam_knowledge: [],
    read_engineering_drawings: '',
    gdt_knowledge: '',
    tool_setting_offsets: '',
    job_skills_checklist: [],
    // Mechanic specific fields
    worked_with: [],
    previous_company_name: '',
    mechanic_skills: [],
    vehicle_experience: [],
    diagnostic_scanner_use: '',
    read_wiring_diagrams: '',
    work_independently: '',
    mechanic_driving_license: '',
    // Welder specific fields
    industry: '',
    other_industry: '',
    welding_process: [],
    welding_positions: [],
    material_experience: [],
    thickness_worked_on: [],
    welder_technical_knowledge: [],
    iti_trade_certificate: '',
    welding_certificate: '',
    welding_certificate_type: '',
    passed_trade_test: '',
    ready_for_trade_test: '',
    fabricator_technical_skills: [],
    fabricator_tools_knowledge: [],
    ac_systems: [],
    hvac_systems: [],
    ac_technical_skills: [],
    ac_tools_knowledge: [],
    chiller_type: [],
    chiller_system_knowledge: [],
    chiller_technical_skills: [],
    chiller_refrigerant_knowledge: [],
    chiller_tools_knowledge: [],
    lathe_machine_knowledge: [],
    milling_machine_knowledge: [],
    lathe_technical_skills: [],
    lathe_material_experience: [],
    elevator_field_experience: [],
    elevator_system_knowledge: [],
    elevator_control_experience: [],
    elevator_brand_experience: [],
    elevator_technical_diploma: '',
    elevator_safety_training: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [jobPositions, setJobPositions] = useState([]);
  const isDriverSelected = formData.job_position.includes("Driver") || formData.job_position.includes("Driver (Company / House)") || formData.job_position.includes("Home Driver") || formData.job_position.includes("Company Driver") || formData.job_position.includes("Light Driver") || formData.job_position.includes("Lady Driver") || formData.job_position.includes("Personal Driver") || formData.job_position.includes("Bus Driver") || formData.job_position.includes("Taxi Driver") || formData.job_position.includes("Heavy Driver");

  // Updated position checks to match the second code
  const isNurseSelected = formData.job_position.some(position => {
    const normalizedPosition = String(position || "").toLowerCase();
    return normalizedPosition.includes("nurse") || normalizedPosition.includes("physiotherapy");
  });
  const isHospitalOrHealthcareCategory = ["hospital", "healthcare"].includes(
    String(formData.category || "").toLowerCase()
  );

  const isDoctorSelected = formData.job_position.some(position => {
    const pos = position.toLowerCase();
    return pos.includes("doctor") ||
      pos.includes("physician") ||
      pos.includes("surgeon") ||
      pos.includes("pediatrician") ||
      pos.includes("gynecologist") ||
      pos.includes("orthopedic") ||
      pos.includes("cardiologist") ||
      pos.includes("neurologist") ||
      pos.includes("dermatologist") ||
      pos.includes("ent") ||
      pos.includes("ophthalmologist") ||
      pos.includes("anesthesiologist") ||
      pos.includes("radiologist") ||
      pos.includes("psychiatrist") ||
      pos.includes("medical officer") ||
      pos.includes("dental");
  });
  const isHealthcareProfileSelected = isNurseSelected || isDoctorSelected;

  const isTailorSelected = formData.job_position && formData.job_position.includes("Tailor");
  const isBeauticianSelected = formData.job_position && formData.job_position.includes("Beautician");
  const isTeacherSelected = formData.job_position && formData.job_position.includes("Teacher");
  const cncProgrammerCriteria = [
    "CNC Programmer",
    "CNC Milling Programmer",
    "CNC Turning Programmer",
    "CNC 5-Axis Programmer",
    "CNC CAD/CAM Programmer"
  ];

  const cncOperatorCriteria = [
    "CNC Machinist",
    "CNC Setter",
    "CNC Setup Operator",
    "CNC Quality Inspector (CMM)",
    "CNC Maintenance Technician",
    "CNC Tool Room Technician",
    "CNC Production Technician",
    "CNC Machine Operator",
    "CNC Milling Operator",
    "CNC Turning Operator",
    "CNC Lathe Operator",
    "CNC VMC Operator",
    "CNC HMC Operator",
    "CNC Operator"
  ];

  const isCncProgrammerSelected = formData.job_position && formData.job_position.some(pos => cncProgrammerCriteria.includes(pos));
  const isCncOperatorSelected = formData.job_position && formData.job_position.some(pos => cncOperatorCriteria.includes(pos));
  const isMechanicSelected = formData.job_position && formData.job_position.some(pos => pos.toLowerCase().includes("mechanic"));
  const isWelderSelected = formData.job_position && formData.job_position.some(pos => pos.trim() === "Welder" || pos.trim() === "MIG Welder" || pos.trim() === "TIG Welder" || pos.trim() === "Industrial Welder" || pos.trim() === "Steel Structure Welder" || pos.trim() === "6G Welder" || pos.trim() === "6G Certified Pipe Welder" || pos.trim() === "6G TIG + SMAW Pipe Welder" || pos.trim() === "6G / 6GR Pipe Welder" || pos.trim() === "High Pressure 6G Pipe Welder" || pos.trim() === "ASME 6G Pipe Welder" || pos.trim() === "6G Oil & Gas Pipe Welder" || pos.trim() === "Shipyard Welder" || pos.trim() === "FCAW Welder (Shipyard)" || pos.trim() === "MIG/MAG Welder (Shipyard)" || pos.trim() === "TIG Welder (Shipyard)" || pos.trim() === "6G Pipe Welder (Shipyard)");
  const isFabricatorSelected = formData.job_position && formData.job_position.includes("Fabricator");
  const isPipeFitterSelected = formData.job_position && formData.job_position.includes("Pipe Fitter");
  const isACTechnicianSelected = formData.job_position && formData.job_position.includes("AC Technician");
  const isHVACTechnicianSelected = formData.job_position && formData.job_position.includes("HVAC Technician");
  const isChillerTechnicianSelected = formData.job_position && formData.job_position.includes("Chiller Technician");
  const isElevatorTechnicianSelected = formData.job_position && formData.job_position.some(pos => pos && (
    pos === "Elevator Technician" ||
    pos === "Elevator Installation Technician" ||
    pos === "Elevator Maintenance Technician" ||
    pos === "Elevator Repair Technician" ||
    pos === "Escalator Technician"
  ));
  const isLatheMachineSelected = formData.job_position && formData.job_position.some(pos => pos.includes("Lathe") || pos.includes("Milling Machine"));

  const isElectricianSelected = formData.job_position && formData.job_position.some(pos => {
    const p = pos.trim().toLowerCase();
    return p === "electrician" || p === "industrial electrician" || p === "electrical technician" || p === "maintenance electrician" || p === "panel electrician";
  });
  const [showNote, setShowNote] = useState(false);

  // Helper function to filter options for dropdown
  const filterOptions = (options, searchTerm) => {
    const normalizedOptions = Array.from(
      new Set(
        (Array.isArray(options) ? options : [])
          .map((option) => String(option ?? '').trim())
          .filter(Boolean)
      )
    );

    if (!searchTerm) return normalizedOptions;

    const normalizedSearchTerm = searchTerm.toLowerCase().trim();
    return normalizedOptions.filter((option) =>
      option.toLowerCase().includes(normalizedSearchTerm)
    );
  };

  const MultiSelectDropdown = ({
    title,
    field,
    options,
    selectedValues = [],
    onSelect,
    required = false,
    error = null,
    className = "",
    maxSelections = 4
  }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleSelection = (value) => {
      onSelect(field, value);
    };

    return (
      <div className="mb-3">
        <Dropdown show={isOpen} onToggle={(isOpen) => setIsOpen(isOpen)}>
          <Dropdown.Toggle
            variant="light"
            className={`w-100 d-flex justify-content-between align-items-center ${className} ${error ? 'is-invalid' : ''}`}
            id={`dropdown-${field}`}
            style={{
              textAlign: 'left',
              border: '1px solid #ced4da',
              borderRadius: '0px',
              backgroundColor: '#aec9f3',
              padding: '0.375rem 0.75rem',
              color: selectedValues.length > 0 ? '#212529' : '#000',
              minHeight: '60px',
              fontSize: '21px',
              fontWeight: '500'
            }}
          >
            <span className="text-truncate">
              {selectedValues.length > 0
                ? `${selectedValues.length} selected (${selectedValues.join(', ')})`
                : `${title}${required ? ' *' : ''}`
              }
            </span>
            <FaChevronDown className="ms-2" size={14} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="w-100 p-2"
            style={{
              maxHeight: 'none',
              overflow: 'hidden',
              backgroundColor: 'white',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
            onClick={(e) => e.stopPropagation()} // Prevent close on menu click
          >
            {/* Search Input */}
            <div className="px-2 mb-2 position-relative">
              <FaSearch
                className="position-absolute"
                style={{ top: '12px', left: '20px', color: '#6c757d' }}
                size={14}
              />
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="ps-4"
                style={{ paddingLeft: '35px' }}
                autoFocus
              />
            </div>

            {/* Selected items count */}
            <div className="px-2 mb-2 small text-muted">
              Selected: {selectedValues.length}/{maxSelections}
            </div>

            {/* Options List */}
            <div className="dropdown-options" style={{ maxHeight: '250px', overflowY: 'auto', overflowX: 'hidden' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={`${field}-${option}-${index}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSelection(option);
                    }}
                    className={`dropdown-item py-2 d-flex align-items-center ${selectedValues.includes(option) ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="form-check mb-0 d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        checked={selectedValues.includes(option)}
                        onChange={() => { }} // Handled by div onClick
                        style={{ cursor: 'pointer', pointerEvents: 'none' }} // Disable pointer events on checkbox to rely on div click
                      />
                      <label className="form-check-label mb-0" style={{ cursor: 'pointer', color: 'black' }}>
                        {option}
                      </label>
                    </div>
                  </div>
                ))
              ) : (
                <div className="dropdown-item disabled text-center py-2">No options found</div>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </div>
    );
  };

  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = '',
    allowClear = true,
    isMultiSelect = false // Add this prop for array fields
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    const handleClear = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (isMultiSelect) {
        // For multi-select fields that use toggle functions
        onSelect(field, ''); // This will trigger the toggle function with empty string
      } else {
        onSelect(field, '');
      }
      setIsOpen(false);
      setLocalSearchTerm('');
    };

    const handleToggle = (nextShow) => {
      setIsOpen(nextShow);
      if (!nextShow) {
        setLocalSearchTerm('');
      }
    };

    const handleDropdownClick = (e) => {
      e.stopPropagation();
    };

    // Get display text for multi-select
    const getDisplayText = () => {
      if (!selectedValue || selectedValue === '') {
        return `${title}${required ? ' *' : ''}`;
      }
      if (Array.isArray(selectedValue) && selectedValue.length > 0) {
        return selectedValue[0]; // Show first selected item
      }
      return selectedValue;
    };

    return (
      <div onClick={handleDropdownClick}>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={handleToggle}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            <span className="text-truncate">
              {getDisplayText()}
            </span>
            {selectedValue && selectedValue !== '' && allowClear && (
              <span
                className="clear-button ms-2"
                onClick={handleClear}
                style={{
                  cursor: 'pointer',
                  color: '#dc3545',
                  fontWeight: 'bold',
                  fontSize: '1.2rem',
                  lineHeight: '1',
                  padding: '0 8px',
                  marginLeft: '5px',
                  zIndex: 1000,
                  position: 'relative'
                }}
                title="Clear selection"
              >
                ×
              </span>
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>

            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            {allowClear && selectedValue && selectedValue !== '' && (
              <Dropdown.Item
                onClick={handleClear}
                className="text-danger fw-bold border-bottom"
              >
                <i className="bi bi-x-circle me-2"></i>
                Clear Selection
              </Dropdown.Item>
            )}
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <Dropdown.Item
                    key={`${field}-${option}-${index}`}
                    active={Array.isArray(selectedValue) ? selectedValue.includes(option) : selectedValue === option}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Add this useEffect to check if default value is set
  useEffect(() => {
    console.log('Current nursing_qualifications:', formData.nursing_qualifications);
  }, [formData.nursing_qualifications]);

  useEffect(() => {
    const fetchJobPositions = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/jobposition/`);
        if (response.ok) {
          const data = await response.json();
          setJobPositions(data);
        } else {
          throw new Error('Failed to fetch job positions');
        }
      } catch (err) {
        console.error('Error fetching job positions:', err);
      }
    };

    fetchJobPositions();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchJobSeekerData = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setFormData(prev => ({
              ...prev,
              ...data,
              category: data.category || 'Domestic Helper',
              job_position: safeJsonParse(data.job_position),
              // Handle preferred_start_date - keep existing if available, otherwise use default
              preferred_start_date: data.preferred_start_date === 'Immediate'
                ? 'Immediate'
                : (data.preferred_start_date ? new Date(data.preferred_start_date) : 'Immediate'), // Default to Immediate if no data
              current_work_status: data.current_work_status || 'Finished contract', // Default to Finished contract if no data
              hospitality_experience_types: safeJsonParse(data.hospitality_experience_types),
              software_it_programming_languages: safeJsonParse(data.software_it_programming_languages),
              software_it_frameworks: safeJsonParse(data.software_it_frameworks),
              software_it_database_skills: safeJsonParse(data.software_it_database_skills),
              software_it_other_skills: safeJsonParse(data.software_it_other_skills),
              software_it_certifications: safeJsonParse(data.software_it_certifications),
              software_it_other_programming_language: data.software_it_other_programming_language || '',
              software_it_other_certification: data.software_it_other_certification || '',
              driving_license_country: (data.driving_license_country && safeJsonParse(data.driving_license_country).length > 0)
                ? safeJsonParse(data.driving_license_country)
                : ["Qatar", "Saudi"],
              car_type: (data.car_type && safeJsonParse(data.car_type).length > 0)
                ? safeJsonParse(data.car_type)
                : ["Manual", "Semi Automatic", "Fully Automatic"],
              previous_car: (data.previous_car && safeJsonParse(data.previous_car).length > 0)
                ? safeJsonParse(data.previous_car)
                : ["Land Cruiser", "Nissan Patrol", "Toyota Camry"],
              nursing_qualifications: data.nursing_qualifications
                ? safeJsonParse(data.nursing_qualifications)
                : ["Certificate in Nursing"],
              professional_qualifications: safeJsonParse(data.professional_qualifications),
              specialized_qualifications: safeJsonParse(data.specialized_qualifications),
              language_qualifications: safeJsonParse(data.language_qualifications),
              cultural_adaptation_qualifications: safeJsonParse(data.cultural_adaptation_qualifications),
              nursing_job_countries: data.nursing_job_countries
                ? safeJsonParse(data.nursing_job_countries)
                : ["Qatar"],
              language_skills: data.language_skills
                ? safeJsonParse(data.language_skills)
                : ["English"],
              nursing_license_countries: safeJsonParse(data.nursing_license_countries),
              nursing_positions: safeJsonParse(data.nursing_positions),
              // Tailor fields
              tailor_mode: data.tailor_mode || '',
              tailor_type: data.tailor_type || '',
              stitching_preferences: safeJsonParse(data.stitching_preferences),
              fabric_preference: safeJsonParse(data.fabric_preference),
              style_preference: safeJsonParse(data.style_preference),
              other_skills: safeJsonParse(data.other_skills),
              // Beautician fields
              beautician_mode: data.beautician_mode || '',
              beautician_type: data.beautician_type || '',
              henna_services: safeJsonParse(data.henna_services),
              makeup_services: safeJsonParse(data.makeup_services),
              skin_care_services: safeJsonParse(data.skin_care_services),
              nail_services: safeJsonParse(data.nail_services),
              hair_services: safeJsonParse(data.hair_services),
              massage_spa_services: safeJsonParse(data.massage_spa_services),
              other_trending_services: safeJsonParse(data.other_trending_services),
              banned_country: data.banned_country || '',
              // Teacher fields
              teaching_mode: safeJsonParse(data.teaching_mode),
              subjects: safeJsonParse(data.subjects),
              age_groups: safeJsonParse(data.age_groups),
              classes: safeJsonParse(data.classes),
              daily_hours: safeJsonParse(data.daily_hours),
              curriculum: safeJsonParse(data.curriculum),
              special_skills: safeJsonParse(data.special_skills),
              sports_games: safeJsonParse(data.sports_games),
              sports_age_groups: safeJsonParse(data.sports_age_groups),
              training_mode: safeJsonParse(data.training_mode),
              // CNC Programmer fields
              gulf_europe_experience: data.gulf_europe_experience || '',
              gulf_europe_countries: safeJsonParse(data.gulf_europe_countries),
              industry_experience: data.industry_experience || '',
              cnc_controls: safeJsonParse(data.cnc_controls),
              cnc_machines: safeJsonParse(data.cnc_machines),
              programming_type: data.programming_type || '',
              cad_cam_knowledge: safeJsonParse(data.cad_cam_knowledge),
              read_engineering_drawings: data.read_engineering_drawings || '',
              gdt_knowledge: data.gdt_knowledge || '',
              tool_setting_offsets: data.tool_setting_offsets || '',
              job_skills_checklist: safeJsonParse(data.job_skills_checklist),
              // Mechanic fields
              worked_with: safeJsonParse(data.worked_with),
              previous_company_name: data.previous_company_name || '',
              mechanic_skills: safeJsonParse(data.mechanic_skills),
              vehicle_experience: safeJsonParse(data.vehicle_experience),
              diagnostic_scanner_use: data.diagnostic_scanner_use || '',
              read_wiring_diagrams: data.read_wiring_diagrams || '',
              work_independently: data.work_independently || '',
              mechanic_driving_license: data.mechanic_driving_license || '',
              // Ensure job_type has a default value if not present in fetched data
              job_type: data.job_type || 'Full Time',
              // Convert database 1/0 values to true/false for Prometric and Dataflow
              has_prometric_certificate: data.has_prometric_certificate === 1 ? true :
                data.has_prometric_certificate === 0 ? false :
                  data.has_prometric_certificate === 'Applied' ? 'Applied' : null,
              has_dataflow_certificate: data.has_dataflow_certificate === 1 ? true :
                data.has_dataflow_certificate === 0 ? false :
                  data.has_dataflow_certificate === 'Applied' ? 'Applied' : null,
              // Date fields
              prometric_issue_date: data.prometric_issue_date ? new Date(data.prometric_issue_date) : null,
              prometric_expiry_date: data.prometric_expiry_date ? new Date(data.prometric_expiry_date) : null,
              dataflow_issue_date: data.dataflow_issue_date ? new Date(data.dataflow_issue_date) : null,
              dataflow_expiry_date: data.dataflow_expiry_date ? new Date(data.dataflow_expiry_date) : null,
              prometric_issued_country: data.prometric_issued_country || '',
              dataflow_issued_country: data.dataflow_issued_country || '',
              // Fix the is_ban field - handle both string "0"/"1" and number 0/1
              is_ban:
                data.is_ban === true ||
                  data.is_ban === 'true' ||
                  data.is_ban === 'Yes' ||
                  data.is_ban === '1' ||
                  data.is_ban === 1
                  ? true
                  : data.is_ban === false ||
                    data.is_ban === 'false' ||
                    data.is_ban === 'No' ||
                    data.is_ban === '0' ||
                    data.is_ban === 0
                    ? false
                    : false,
              // Add welder specific fields mapping
              industry: data.industry || '',
              other_industry: data.other_industry || '',
              welding_process: safeJsonParse(data.welding_process),
              welding_positions: safeJsonParse(data.welding_positions),
              material_experience: safeJsonParse(data.material_experience),
              thickness_worked_on: safeJsonParse(data.thickness_worked_on),
              welder_technical_knowledge: safeJsonParse(data.welder_technical_knowledge),
              iti_trade_certificate: data.iti_trade_certificate || '',
              welding_certificate: data.welding_certificate || '',
              welding_certificate_type: data.welding_certificate_type || '',
              passed_trade_test: data.passed_trade_test || '',
              ready_for_trade_test: data.ready_for_trade_test || '',
              // Fabricator & Pipe Fitter fields
              fabricator_technical_skills: safeJsonParse(data.fabricator_technical_skills),
              fabricator_tools_knowledge: safeJsonParse(data.fabricator_tools_knowledge),
              // AC & HVAC Technician fields
              ac_systems: safeJsonParse(data.ac_systems),
              hvac_systems: safeJsonParse(data.hvac_systems),
              ac_technical_skills: safeJsonParse(data.ac_technical_skills),
              ac_tools_knowledge: safeJsonParse(data.ac_tools_knowledge),
              // Chiller Technician fields
              chiller_type: safeJsonParse(data.chiller_type),
              chiller_system_knowledge: safeJsonParse(data.chiller_system_knowledge),
              chiller_technical_skills: safeJsonParse(data.chiller_technical_skills),
              chiller_refrigerant_knowledge: safeJsonParse(data.chiller_refrigerant_knowledge),
              chiller_tools_knowledge: safeJsonParse(data.chiller_tools_knowledge),
              // Lathe & Milling Machine fields
              lathe_machine_knowledge: safeJsonParse(data.lathe_machine_knowledge),
              milling_machine_knowledge: safeJsonParse(data.milling_machine_knowledge),
              lathe_technical_skills: safeJsonParse(data.lathe_technical_skills),
              lathe_material_experience: safeJsonParse(data.lathe_material_experience),
              // Elevator Technician fields
              elevator_field_experience: safeJsonParse(data.elevator_field_experience),
              elevator_system_knowledge: safeJsonParse(data.elevator_system_knowledge),
              elevator_control_experience: safeJsonParse(data.elevator_control_experience),
              elevator_brand_experience: safeJsonParse(data.elevator_brand_experience),
              elevator_technical_diploma: data.elevator_technical_diploma || '',
              elevator_safety_training: data.elevator_safety_training || '',
              // Set visa_type default if not present
              visa_type: data.visa_type || 'Looking for visa'
            }));
            setIsSaved(true);
          }
        }
      } catch (err) {
        console.error('Error fetching job seeker data:', err);
        setError(err.message);
      }
    };

    if (userId) {
      fetchJobSeekerData();
    }
  }, [userId]);

  // Effect to automatically select "Company Worker" if CNC, Mechanic, Welder, or Electrician role is chosen
  useEffect(() => {
    if (isCncProgrammerSelected || isCncOperatorSelected || isMechanicSelected || isWelderSelected || isElectricianSelected || isFabricatorSelected || isPipeFitterSelected || isACTechnicianSelected || isHVACTechnicianSelected || isChillerTechnicianSelected || isLatheMachineSelected || isElevatorTechnicianSelected) {
      if (formData.category !== "Company Worker") {
        setFormData(prev => ({
          ...prev,
          category: "Company Worker"
        }));
      }
    }
  }, [isCncProgrammerSelected, isCncOperatorSelected, isMechanicSelected, isWelderSelected, isElectricianSelected, isFabricatorSelected, isPipeFitterSelected, isACTechnicianSelected, isHVACTechnicianSelected, isChillerTechnicianSelected, isLatheMachineSelected, isElevatorTechnicianSelected, formData.category]);

  // Automate default selection for Welder
  useEffect(() => {
    if (isWelderSelected) {
      setFormData(prev => {
        let hasChanges = false;
        const updates = {};

        if (!prev.industry) {
          updates.industry = 'Oil & Gas';
          hasChanges = true;
        }
        if (!prev.welding_process || prev.welding_process.length === 0) {
          updates.welding_process = ['MIG (GMAW)', 'TIG (GTAW)', 'FCAW'];
          hasChanges = true;
        }
        if (!prev.welding_positions || prev.welding_positions.length === 0) {
          updates.welding_positions = ['1G', '2G', '3G', '4G', '5G', '6G'];
          hasChanges = true;
        }
        if (!prev.material_experience || prev.material_experience.length === 0) {
          updates.material_experience = ['Carbon Steel', 'Stainless Steel'];
          hasChanges = true;
        }
        if (!prev.thickness_worked_on || prev.thickness_worked_on.length === 0) {
          updates.thickness_worked_on = ['1–3 mm (Sheet metal)', '3–6 mm', '6–12 mm'];
          hasChanges = true;
        }
        if (!prev.welder_technical_knowledge || prev.welder_technical_knowledge.length === 0) {
          updates.welder_technical_knowledge = [
            'Read welding drawings', 'Read isometric drawings',
            'Fit-up knowledge', 'Grinding & gas cutting',
            'Working as per WPS'
          ];
          hasChanges = true;
        }
        if (!prev.iti_trade_certificate) {
          updates.iti_trade_certificate = 'Yes';
          hasChanges = true;
        }
        if (!prev.welding_certificate) {
          updates.welding_certificate = 'Yes';
          hasChanges = true;
        }
        if (!prev.welding_certificate_type) {
          updates.welding_certificate_type = '6G';
          hasChanges = true;
        }
        if (!prev.passed_trade_test) {
          updates.passed_trade_test = 'Yes';
          hasChanges = true;
        }
        if (!prev.ready_for_trade_test) {
          updates.ready_for_trade_test = 'Yes';
          hasChanges = true;
        }

        return hasChanges ? { ...prev, ...updates } : prev;
      });
    }
  }, [isWelderSelected]);

  // Helper function to safely parse JSON
  function safeJsonParse(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      if (typeof value === 'string') {
        return [value];
      }
      return Array.isArray(value) ? value : [value];
    }
  }

  const updateField = (field, value) => {
    const dateFields = [
      'visa_issued_date', 'visa_expiry_date', 'current_employment_date',
      'current_finish_contract_date', 'previous_employment_date',
      'previous_finish_contract_date', 'prometric_issue_date',
      'prometric_expiry_date', 'dataflow_issue_date',
      'dataflow_expiry_date', 'nursing_license_issue_date',
      'nursing_license_expiry_date'
    ];

    let processedValue = value;

    if (dateFields.includes(field)) {
      if (typeof value === 'string') {
        processedValue = new Date(value);
        if (isNaN(processedValue.getTime())) {
          processedValue = null;
        }
      }
    }

    // If category is being changed, reset job positions if switching to/from "Company"
    if (field === 'category') {
      if ((value === 'Company Worker' && formData.category !== 'Company Worker') ||
        (value !== 'Company Worker' && formData.category === 'Company Worker')) {
        setFormData(prev => ({
          ...prev,
          [field]: processedValue,
          job_position: []
        }));
        return;
      }
    }

    setFormData(prev => ({ ...prev, [field]: processedValue }));
    setError(null);
    setIsSaved(false);
  };

  const togglePosition = (position) => {
    const updated = formData.job_position.includes(position)
      ? []
      : [position];
    updateField('job_position', updated);
  };

  const toggleHospitalityExperienceType = (type) => {
    const current = formData.hospitality_experience_types || [];
    const updated = current.includes(type)
      ? current.filter((item) => item !== type)
      : [...current, type];
    updateField('hospitality_experience_types', updated);
  };

  const toggleSoftwareItSelection = (field, value) => {
    const current = formData[field] || [];
    const updated = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value];
    updateField(field, updated);
  };

  const toggleLicenseCountry = (country) => {
    const noLicenseLabel = "Not Licensed";
    const updated = formData.driving_license_country.includes(country)
      ? formData.driving_license_country.filter(item => item !== country)
      : (country === noLicenseLabel
        ? [noLicenseLabel]
        : [...formData.driving_license_country.filter(item => item !== noLicenseLabel), country].slice(0, 3));
    updateField('driving_license_country', updated);
  };

  const toggleCarType = (type) => {
    const updated = formData.car_type.includes(type)
      ? formData.car_type.filter(item => item !== type)
      : [...formData.car_type, type].slice(0, 3);
    updateField('car_type', updated);
  };

  const togglePreviousCar = (car) => {
    const updated = formData.previous_car.includes(car)
      ? formData.previous_car.filter(item => item !== car)
      : [...formData.previous_car, car].slice(0, 3);
    updateField('previous_car', updated);
  };

  const toggleNursingQualification = (qualification) => {
    const updated = formData.nursing_qualifications.includes(qualification)
      ? formData.nursing_qualifications.filter(item => item !== qualification)
      : [...formData.nursing_qualifications, qualification];
    updateField('nursing_qualifications', updated);
  };

  const toggleProfessionalQualification = (qualification) => {
    const updated = formData.professional_qualifications.includes(qualification)
      ? formData.professional_qualifications.filter(item => item !== qualification)
      : [...formData.professional_qualifications, qualification];
    updateField('professional_qualifications', updated);
  };

  const toggleSpecializedQualification = (qualification) => {
    const updated = formData.specialized_qualifications.includes(qualification)
      ? formData.specialized_qualifications.filter(item => item !== qualification)
      : [...formData.specialized_qualifications, qualification];
    updateField('specialized_qualifications', updated);
  };

  const toggleLanguageQualification = (qualification) => {
    const updated = formData.language_qualifications.includes(qualification)
      ? formData.language_qualifications.filter(item => item !== qualification)
      : [...formData.language_qualifications, qualification];
    updateField('language_qualifications', updated);
  };

  const toggleCulturalAdaptationQualification = (qualification) => {
    const updated = formData.cultural_adaptation_qualifications.includes(qualification)
      ? formData.cultural_adaptation_qualifications.filter(item => item !== qualification)
      : [...formData.cultural_adaptation_qualifications, qualification];
    updateField('cultural_adaptation_qualifications', updated);
  };

  const toggleNursingJobCountry = (country) => {
    const updated = formData.nursing_job_countries.includes(country)
      ? formData.nursing_job_countries.filter(item => item !== country)
      : [...formData.nursing_job_countries, country];
    updateField('nursing_job_countries', updated);
  };

  const toggleLanguageSkill = (language) => {
    const updated = formData.language_skills.includes(language)
      ? formData.language_skills.filter(item => item !== language)
      : [...formData.language_skills, language];
    updateField('language_skills', updated);
  };

  const toggleNursingLicenseCountry = (country) => {
    const noLicenseLabel = "Not Licensed";
    const updated = formData.nursing_license_countries.includes(country)
      ? formData.nursing_license_countries.filter(item => item !== country)
      : (country === noLicenseLabel
        ? [noLicenseLabel]
        : [...formData.nursing_license_countries.filter(item => item !== noLicenseLabel), country]);
    updateField('nursing_license_countries', updated);
  };

  const toggleNursingPosition = (position) => {
    const updated = formData.nursing_positions.includes(position)
      ? formData.nursing_positions.filter(item => item !== position)
      : [...formData.nursing_positions, position];
    updateField('nursing_positions', updated);
  };

  const toggleGulfEuropeCountries = (country) => {
    const current = formData.gulf_europe_countries || [];
    const updated = current.includes(country)
      ? current.filter(item => item !== country)
      : [...current, country].slice(0, 3);
    updateField('gulf_europe_countries', updated);
  };

  const toggleCncControls = (control) => {
    const current = formData.cnc_controls || [];
    const updated = current.includes(control)
      ? current.filter(item => item !== control)
      : [...current, control];
    updateField('cnc_controls', updated);
  };

  const toggleCncMachines = (machine) => {
    const current = formData.cnc_machines || [];
    const updated = current.includes(machine)
      ? current.filter(item => item !== machine)
      : [...current, machine];
    updateField('cnc_machines', updated);
  };

  const toggleCadCamKnowledge = (knowledge) => {
    const current = formData.cad_cam_knowledge || [];
    const updated = current.includes(knowledge)
      ? current.filter(item => item !== knowledge)
      : [...current, knowledge];
    updateField('cad_cam_knowledge', updated);
  };

  const toggleJobSkillsChecklist = (skill) => {
    const current = formData.job_skills_checklist || [];
    const updated = current.includes(skill)
      ? current.filter(item => item !== skill)
      : [...current, skill];
    updateField('job_skills_checklist', updated);
  };

  const toggleMachinesOperated = (machine) => {
    const current = formData.machines_operated || [];
    const updated = current.includes(machine)
      ? current.filter(item => item !== machine)
      : [...current, machine];
    updateField('machines_operated', updated);
  };

  const toggleTechnicalSkills = (skill) => {
    const current = formData.technical_skills || [];
    const updated = current.includes(skill)
      ? current.filter(item => item !== skill)
      : [...current, skill];
    updateField('technical_skills', updated);
  };

  const toggleSoftwareKnowledge = (software) => {
    const current = formData.software_knowledge || [];
    const updated = current.includes(software)
      ? current.filter(item => item !== software)
      : [...current, software];
    updateField('software_knowledge', updated);
  };

  const toggleMechanicWorkedWith = (workedWith) => {
    setFormData(prev => {
      const current = prev.worked_with || [];
      if (current.includes(workedWith)) {
        return { ...prev, worked_with: current.filter(item => item !== workedWith) };
      } else {
        return { ...prev, worked_with: [...current, workedWith] };
      }
    });
  };

  const toggleMechanicSkills = (skill) => {
    setFormData(prev => {
      const current = prev.mechanic_skills || [];
      if (current.includes(skill)) {
        return { ...prev, mechanic_skills: current.filter(item => item !== skill) };
      } else {
        return { ...prev, mechanic_skills: [...current, skill] };
      }
    });
  };

  const toggleMechanicVehicleExperience = (vehicle) => {
    setFormData(prev => {
      const current = prev.vehicle_experience || [];
      if (current.includes(vehicle)) {
        return { ...prev, vehicle_experience: current.filter(item => item !== vehicle) };
      } else {
        return { ...prev, vehicle_experience: [...current, vehicle] };
      }
    });
  };

  // Filter job positions based on category
  const cncPositions = [
    "CNC Machinist",
    "CNC Programmer",
    "CNC Milling Programmer",
    "CNC Turning Programmer",
    "CNC 5-Axis Programmer",
    "CNC CAD/CAM Programmer",
    "CNC Setter",
    "CNC Setup Operator",
    "CNC Quality Inspector (CMM)",
    "CNC Maintenance Technician",
    "CNC Tool Room Technician",
    "CNC Production Technician",
    "CNC Machine Operator",
    "CNC Milling Operator",
    "CNC Turning Operator",
    "CNC Lathe Operator",
    "CNC VMC Operator",
    "CNC HMC Operator"
  ];
  const jobPositionOptions = Array.from(new Set([
    "Home Care Nurse", "Company Driver", "Light Driver",
    ...DOMESTIC_HELPER_POSITIONS, "Driver (Company / House)",
    "Bus Driver", "Plumber", "Taxi Driver", "Operator", "Electrician",
    "Welder", "6G Certified Pipe Welder", "6G TIG + SMAW Pipe Welder", "6G / 6GR Pipe Welder",
    "High Pressure 6G Pipe Welder", "ASME 6G Pipe Welder", "6G Oil & Gas Pipe Welder",
    "Nurse",
    "Hospital Nurse", "Physiotherapy", "Midwife (Midwifery)", "Hospital Doctor", "Resident Doctor", "Heavy Driver",
    "Bike Driver",
    "JCB Operator",
    "Bulldozer Operator",
    "Excavator Operator",
    "Loader Operator",
    "Skid Steer Loader Operator",
    "Grader Operator",
    "Trench Excavator / Trencher Operator",
    "Backhoe Operator",
    "Dragline Operator",
    "Scraper Operator",
    "Crane Operator",
    "Telehandler Operator",
    "Reach Stacker Operator",
    "Boom Lift / Cherry Picker Operator",
    "Container Handler Operator",
    "Road Roller Operator",
    "Asphalt Paver Operator",
    "Bitumen Sprayer Operator",
    "Concrete Paver Operator",
    "Soil Stabilizer Operator",
    "Drilling Machine / Drill Rig Operator",
    "Rock Breaker / Hydraulic Hammer Operator",
    "Loader-Dumper Operator",
    "Dump Truck Operator",
    "Stone Crusher Operator",
    "Grizzly Feeder / Conveyor Operator",
    "Tractor Operator",
    "Harvester / Combine Operator",
    "Dozer / Land Leveling Operator",
    "Tower Crane Operator",
    "Mobile Crane Operator",
    "Crawler Crane Operator",
    "Piling Machine Operator",
    "Concrete Mixer Truck Operator",
    "Concrete Pump Operator",
    "Compactor Operator",
    "Pipe Layer Operator",
    "Forklift / Warehouse Equipment Operator",
    "Boom Truck / Loader Crane Operator",
    "Road Sweeper Operator",
    "Water Tanker / Firefighting Vehicle Operator",
    "Excavator Mounted Drill Operator",
    "Heavy Truck / Tip Truck Operator",
    "Loader Excavator Operator",
    "Teleporter Crane Operator",
    "Material Handler / Port Crane Operator",
    "Hydraulic Excavator Operator",
    "Multi-Functional Heavy M",
    "Workers", "Skilled Workers", "Construction Workers", "Skilled Construction Workers",
    "Mason", "Carpenter", "Steel Fixer", "Painter", "AC Technician", "HVAC Technician", "Chiller Technician",
    "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",
    "Heavy Equipment Operator", "Scaffolder", "Healthcare Assistants", "Doctors",
    "Lab Technicians", "Physiotherapists", "Elderly Care Workers", ...HOSPITALITY_POSITIONS, ...SOFTWARE_IT_POSITIONS, ...CONSTRUCTION_POSITIONS, ...RETAIL_SALES_POSITIONS, ...CLEANING_MAINTENANCE_POSITIONS, ...SECURITY_POSITIONS, ...OFFICE_STAFF_POSITIONS,
    "Factory Workers", "Production Workers", "Warehouse Workers", "Packing Staff",
    "Machine Operators", "Assembly Line Workers", "Forklift Operators",
    "Delivery Drivers", "Truck Drivers", "Logistics Staff", "Farm Workers",
    "Fruit Pickers", "Dairy Workers", "Poultry Workers", "Greenhouse Workers",
    "Caretakers",
    ...cncPositions,
    "Machine Operator", "Assembly Line Worker", "Production Worker", "MIG Welder",
    "TIG Welder", "Industrial Welder", "Fabricator", "Pipe Fitter", "Steel Structure Welder",
    "Heavy Truck Mechanic", "Diesel Mechanic", "Auto Mechanic", "Bus Mechanic",
    "Vehicle Technician", "Industrial Electrician", "Maintenance Electrician", "Panel Electrician", "Maintenance Technician",
    "Electrical Technician", "PLC Technician", "Automation Technician",
    "Construction Worker", "Warehouse Worker", "Forklift Operator", "Picker & Packer",
    "Delivery Van Driver", "Logistics Assistant", "Heavy Truck Driver (CE)",
    "Trailer Driver", "Chef", "Kitchen Assistant", "Hotel Housekeeping",
    "Medical Technician", "Instrument Technician", "Mechanical Maintenance Technician",
    "Heavy Equipment Mechanic", "6G Welder", "Structural Welder",
    "Heavy Trailer Driver", "Fuel Tanker Driver", "Ready-Mix Driver",
    "Registered Nurse", "Physiotherapy", "Midwife (Midwifery)", "Professional Chef", "Home Nurse",
    "Salesman",
    "Sales Executive",
    "Senior Sales Executive",
    "Outdoor Salesman",
    "Indoor Salesman",
    "Business Development Executive",
    "Marketing Executive",
    "Digital Marketing Executive",
    "Tele-Sales Executive",
    "Account Manager (Sales)",
    "Receptionist",
    "Front Desk Executive",
    "Office Assistant",
    "Office Boy",
    "Office Helper",
    "Admin Assistant",
    "Customer Support Executive",
    "Call Center Agent",
    "Admin Executive",
    "Office Administrator",
    "Operations Executive",
    "Document Controller",
    "Data Entry Operator",
    "HR Assistant",
    "HR Executive",
    "Accountant",
    "Assistant Accountant",
    "Accounts Executive",
    "Cashier",
    "Billing Executive",
    "Payroll Executive",
    "Back Office Executive",
    "Office Coordinator",
    "Project Coordinator",
    "Logistics Coordinator",
    "Sales Coordinator",
    "Office Manager",
    "Operations Manager",
    "Admin Manager",
    "Sales Manager",
    "Elevator Technician",
    "Elevator Installation Technician",
    "Elevator Maintenance Technician",
    "Elevator Repair Technician",
    "Escalator Technician"
  ]));

  const uniquePositionObjects = (positions) =>
    Array.from(
      new Set((positions || []).map((position) => String(position ?? '').trim()).filter(Boolean))
    ).map((position) => ({ position }));

  const getFilteredJobPositions = () => {
    const domesticSet = new Set(DOMESTIC_HELPER_POSITIONS);

    // If category is "Hospital", show only Nurse and Doctor related positions
    if (formData.category === "Hospital") {
      return uniquePositionObjects(HEALTHCARE_POSITIONS);
    }

    if (formData.category === "Domestic Helper") {
      return uniquePositionObjects(
        jobPositionOptions.filter((position) => domesticSet.has(position))
      );
    }

    if (formData.category === HOSPITALITY_CATEGORY) {
      return uniquePositionObjects(HOSPITALITY_POSITIONS);
    }

    if (formData.category === SOFTWARE_IT_CATEGORY) {
      return uniquePositionObjects(SOFTWARE_IT_POSITIONS);
    }

    if (formData.category === CONSTRUCTION_CATEGORY) {
      return uniquePositionObjects(CONSTRUCTION_POSITIONS);
    }

    if (formData.category === RETAIL_SALES_CATEGORY) {
      return uniquePositionObjects(RETAIL_SALES_POSITIONS);
    }

    if (formData.category === CLEANING_MAINTENANCE_CATEGORY) {
      return uniquePositionObjects(CLEANING_MAINTENANCE_POSITIONS);
    }

    if (formData.category === SECURITY_CATEGORY) {
      return uniquePositionObjects(SECURITY_POSITIONS);
    }

    if (formData.category === OFFICE_STAFF_CATEGORY) {
      return uniquePositionObjects(OFFICE_STAFF_POSITIONS);
    }

    if (formData.category === DRIVER_CATEGORY || formData.category === "Driver") {
      return uniquePositionObjects(DRIVER_POSITIONS);
    }

    if (formData.category === "Company Worker") {
      const companyPositions = filterCompanyWorkerPositions({
        positions: jobPositionOptions,
        domesticPositions: DOMESTIC_HELPER_POSITIONS,
        healthcarePositions: HEALTHCARE_POSITIONS
      });
      // Ensure CNC positions are included in Company Worker and follow the sequence
      const nonCncCompanyPositions = companyPositions.filter(pos => !cncPositions.includes(pos));
      return uniquePositionObjects([...cncPositions, ...nonCncCompanyPositions]);
    }

    return uniquePositionObjects(jobPositionOptions);
  };

  useEffect(() => {
    const hasHospitalityPosition = (formData.job_position || []).some((position) =>
      HOSPITALITY_POSITIONS.includes(position)
    );

    if ((!hasHospitalityPosition || formData.category !== HOSPITALITY_CATEGORY) &&
      (formData.hospitality_experience_types || []).length > 0) {
      setFormData((prev) => ({
        ...prev,
        hospitality_experience_types: []
      }));
      setIsSaved(false);
    }
  }, [formData.category, formData.job_position]);

  useEffect(() => {
    const hasSoftwareItPosition = (formData.job_position || []).some((position) =>
      SOFTWARE_IT_POSITIONS.includes(position)
    );

    const hasSoftwareItSelections =
      (formData.software_it_programming_languages || []).length > 0 ||
      (formData.software_it_frameworks || []).length > 0 ||
      (formData.software_it_database_skills || []).length > 0 ||
      (formData.software_it_other_skills || []).length > 0 ||
      (formData.software_it_certifications || []).length > 0 ||
      !!formData.software_it_other_programming_language ||
      !!formData.software_it_other_certification;

    if ((!hasSoftwareItPosition || formData.category !== SOFTWARE_IT_CATEGORY) && hasSoftwareItSelections) {
      setFormData((prev) => ({
        ...prev,
        software_it_programming_languages: [],
        software_it_frameworks: [],
        software_it_database_skills: [],
        software_it_other_skills: [],
        software_it_certifications: [],
        software_it_other_programming_language: '',
        software_it_other_certification: ''
      }));
      setIsSaved(false);
    }
  }, [formData.category, formData.job_position]);

  const saveData = async () => {
    setIsLoading(true);
    setError(null);

    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const toDateString = (date) => {
        if (!date) return null;
        if (date instanceof Date) return date.toISOString().split('T')[0];
        if (typeof date === 'string') {
          const parsedDate = new Date(date);
          if (!isNaN(parsedDate.getTime())) {
            return parsedDate.toISOString().split('T')[0];
          }
        }
        return null;
      };

      const dataToSend = {
        user_id: formData.user_id,
        category: formData.category,
        job_position: JSON.stringify(formData.job_position),
        other_position: formData.other_position,
        is_ban: formData.is_ban,
        ban_reason: formData.ban_reason,
        banned_country: formData.banned_country,
        job_type: formData.job_type,
        preferred_start_date: formData.preferred_start_date === 'Immediate'
          ? 'Immediate'
          : toDateString(formData.preferred_start_date),
        current_work_status: formData.current_work_status,
        visa_type: formData.visa_type,
        visa_issued_date: toDateString(formData.visa_issued_date),
        visa_expiry_date: toDateString(formData.visa_expiry_date),
        noc_or_transfer_letter: formData.noc_or_transfer_letter,
        has_driving_license: formData.has_driving_license === true ? 1 : formData.has_driving_license === false ? 0 : null,
        driving_license_country: JSON.stringify(formData.driving_license_country),
        other_driving_license_country: formData.other_driving_license_country,
        car_type: JSON.stringify(formData.car_type),
        previous_car: JSON.stringify(formData.previous_car),
        other_previous_car: formData.other_previous_car,
        bike_type: JSON.stringify(formData.bike_type),
        previous_bike: JSON.stringify(formData.previous_bike),
        other_previous_bike: formData.other_previous_bike,
        bike_ownership_status: formData.bike_ownership_status,
        delivery_experience_types: JSON.stringify(formData.delivery_experience_types),
        hospitality_experience_types: JSON.stringify(formData.hospitality_experience_types),
        software_it_programming_languages: JSON.stringify(formData.software_it_programming_languages),
        software_it_frameworks: JSON.stringify(formData.software_it_frameworks),
        software_it_database_skills: JSON.stringify(formData.software_it_database_skills),
        software_it_other_skills: JSON.stringify(formData.software_it_other_skills),
        software_it_certifications: JSON.stringify(formData.software_it_certifications),
        software_it_other_programming_language: formData.software_it_other_programming_language,
        software_it_other_certification: formData.software_it_other_certification,
        other_delivery_experience: formData.other_delivery_experience,
        uses_google_maps: formData.uses_google_maps === true ? 1 : formData.uses_google_maps === false ? 0 : null,
        google_maps_experience_level: formData.google_maps_experience_level,
        other_delivery_apps: JSON.stringify(formData.other_delivery_apps),
        other_navigation_apps: formData.other_navigation_apps,
        delivery_company_names: JSON.stringify(formData.delivery_company_names),
        current_hospital_name: formData.current_hospital_name,
        current_hospital_country: formData.current_hospital_country,
        current_employment_date: toDateString(formData.current_employment_date),
        current_finish_contract_date: toDateString(formData.current_finish_contract_date),
        previous_hospital_name: formData.previous_hospital_name,
        previous_hospital_country: formData.previous_hospital_country,
        previous_employment_date: toDateString(formData.previous_employment_date),
        previous_finish_contract_date: toDateString(formData.previous_finish_contract_date),
        nursing_qualifications: JSON.stringify(formData.nursing_qualifications),
        professional_qualifications: JSON.stringify(formData.professional_qualifications),
        specialized_qualifications: JSON.stringify(formData.specialized_qualifications),
        language_qualifications: JSON.stringify(formData.language_qualifications),
        has_prometric_certificate: formData.has_prometric_certificate,
        prometric_issue_date: toDateString(formData.prometric_issue_date),
        prometric_expiry_date: toDateString(formData.prometric_expiry_date),
        prometric_issued_country: formData.prometric_issued_country,
        has_dataflow_certificate: formData.has_dataflow_certificate,
        dataflow_issue_date: toDateString(formData.dataflow_issue_date),
        dataflow_expiry_date: toDateString(formData.dataflow_expiry_date),
        dataflow_issued_country: formData.dataflow_issued_country,
        cultural_adaptation_qualifications: JSON.stringify(formData.cultural_adaptation_qualifications),
        nursing_job_countries: JSON.stringify(formData.nursing_job_countries),
        language_skills: JSON.stringify(formData.language_skills),
        nursing_license_countries: JSON.stringify(formData.nursing_license_countries),
        other_nursing_license_country: formData.other_nursing_license_country,
        nursing_license_issue_date: toDateString(formData.nursing_license_issue_date),
        nursing_license_expiry_date: toDateString(formData.nursing_license_expiry_date),
        has_nursing_license: formData.has_nursing_license,
        no_of_children: formData.no_of_children,
        nursing_positions: JSON.stringify(formData.nursing_positions),
        tailor_mode: formData.tailor_mode,
        tailor_type: formData.tailor_type,
        stitching_preferences: JSON.stringify(formData.stitching_preferences),
        fabric_preference: JSON.stringify(formData.fabric_preference),
        style_preference: JSON.stringify(formData.style_preference),
        other_skills: JSON.stringify(formData.other_skills),
        beautician_mode: formData.beautician_mode,
        beautician_type: formData.beautician_type,
        henna_services: JSON.stringify(formData.henna_services),
        makeup_services: JSON.stringify(formData.makeup_services),
        skin_care_services: JSON.stringify(formData.skin_care_services),
        nail_services: JSON.stringify(formData.nail_services),
        hair_services: JSON.stringify(formData.hair_services),
        massage_spa_services: JSON.stringify(formData.massage_spa_services),
        other_trending_services: JSON.stringify(formData.other_trending_services),
        teaching_mode: JSON.stringify(formData.teaching_mode),
        subjects: JSON.stringify(formData.subjects),
        age_groups: JSON.stringify(formData.age_groups),
        classes: JSON.stringify(formData.classes),
        daily_hours: JSON.stringify(formData.daily_hours),
        curriculum: JSON.stringify(formData.curriculum),
        sports_games: JSON.stringify(formData.sports_games),
        sports_age_groups: JSON.stringify(formData.sports_age_groups),
        training_mode: JSON.stringify(formData.training_mode),
        gulf_europe_experience: formData.gulf_europe_experience,
        gulf_europe_countries: JSON.stringify(formData.gulf_europe_countries),
        industry_experience: formData.industry_experience,
        cnc_controls: JSON.stringify(formData.cnc_controls),
        cnc_machines: JSON.stringify(formData.cnc_machines),
        programming_type: formData.programming_type,
        cad_cam_knowledge: JSON.stringify(formData.cad_cam_knowledge),
        read_engineering_drawings: formData.read_engineering_drawings,
        gdt_knowledge: formData.gdt_knowledge,
        tool_setting_offsets: formData.tool_setting_offsets,
        electrician_industry_type: formData.electrician_industry_type,
        other_electrician_industry: formData.other_electrician_industry,
        electrical_experience: JSON.stringify(formData.electrical_experience),
        automation_controls: JSON.stringify(formData.automation_controls),
        drawing_testing: JSON.stringify(formData.drawing_testing),
        voltage_experience: JSON.stringify(formData.voltage_experience),
        max_voltage: formData.max_voltage,
        iti_diploma_electrical: formData.iti_diploma_electrical,
        electrical_license: formData.electrical_license,
        other_electrical_license: formData.other_electrical_license,
        electrical_trade_test_passed: formData.electrical_trade_test_passed,
        electrical_ready_for_test: formData.electrical_ready_for_test,
        worked_with: JSON.stringify(formData.worked_with),
        previous_company_name: formData.previous_company_name,
        mechanic_skills: JSON.stringify(formData.mechanic_skills),
        vehicle_experience: JSON.stringify(formData.vehicle_experience),
        diagnostic_scanner_use: formData.diagnostic_scanner_use,
        read_wiring_diagrams: formData.read_wiring_diagrams,
        work_independently: formData.work_independently,
        mechanic_driving_license: formData.mechanic_driving_license,
        industry: formData.industry,
        other_industry: formData.other_industry,
        welding_process: JSON.stringify(formData.welding_process),
        welding_positions: JSON.stringify(formData.welding_positions),
        material_experience: JSON.stringify(formData.material_experience),
        thickness_worked_on: JSON.stringify(formData.thickness_worked_on),
        welder_technical_knowledge: JSON.stringify(formData.welder_technical_knowledge),
        iti_trade_certificate: formData.iti_trade_certificate,
        welding_certificate: formData.welding_certificate,
        welding_certificate_type: formData.welding_certificate_type,
        passed_trade_test: formData.passed_trade_test,
        ready_for_trade_test: formData.ready_for_trade_test,
        fabricator_technical_skills: JSON.stringify(formData.fabricator_technical_skills),
        fabricator_tools_knowledge: JSON.stringify(formData.fabricator_tools_knowledge),
        ac_systems: JSON.stringify(formData.ac_systems),
        hvac_systems: JSON.stringify(formData.hvac_systems),
        ac_technical_skills: JSON.stringify(formData.ac_technical_skills),
        ac_tools_knowledge: JSON.stringify(formData.ac_tools_knowledge),
        chiller_type: JSON.stringify(formData.chiller_type),
        chiller_system_knowledge: JSON.stringify(formData.chiller_system_knowledge),
        chiller_technical_skills: JSON.stringify(formData.chiller_technical_skills),
        chiller_refrigerant_knowledge: JSON.stringify(formData.chiller_refrigerant_knowledge),
        chiller_tools_knowledge: JSON.stringify(formData.chiller_tools_knowledge),
        lathe_machine_knowledge: JSON.stringify(formData.lathe_machine_knowledge),
        milling_machine_knowledge: JSON.stringify(formData.milling_machine_knowledge),
        lathe_technical_skills: JSON.stringify(formData.lathe_technical_skills),
        lathe_material_experience: JSON.stringify(formData.lathe_material_experience)
      };

      Object.keys(dataToSend).forEach(key => {
        if (dataToSend[key] === undefined || dataToSend[key] === null) {
          delete dataToSend[key];
        }
      });

      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to save data');
      }

      await Swal.fire({
        title: 'Success!',
        text: 'Your professional information has been saved successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setIsSaved(true);
      return result;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormData = async () => {
    if (!formData.preferred_start_date) {
      await Swal.fire({
        title: 'Error!',
        text: 'Please select a preferred start date',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return false;
    }

    if (formData.is_ban === true && !formData.ban_reason) {
      await Swal.fire({
        title: 'Error!',
        text: 'Please provide a reason for ban',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return false;
    }

    // Teacher-specific validations
    if (isTeacherSelected) {
      if (!formData.teaching_mode || formData.teaching_mode.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one teaching mode',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.subjects || formData.subjects.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one subject you can teach',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.age_groups || formData.age_groups.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one age group',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.classes || formData.classes.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one class level you teach',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.curriculum || formData.curriculum.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one curriculum/board',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    // Driver-specific validations (only when has driving license)
    if (isDriverSelected && formData.has_driving_license === true) {
      if (formData.driving_license_country.length === 0 && !formData.other_driving_license_country) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select or specify at least one driving license country',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (formData.car_type.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one type of car you have driven',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (formData.previous_car.length === 0 && !formData.other_previous_car) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select or specify at least one car you have driven before',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    // Shared healthcare validations for nurse and doctor positions
    if (isHealthcareProfileSelected) {


      // if (formData.nursing_qualifications.length === 0) {
      //   await Swal.fire({
      //     title: 'Error!',
      //     text: 'Please select at least one nursing qualification',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#d33',
      //   });
      //   return false;
      // }

      // if (formData.nursing_job_countries.length === 0) {
      //   await Swal.fire({
      //     title: 'Error!',
      //     text: 'Please select at least one country where you are looking for a nursing job',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#d33',
      //   });
      //   return false;
      // }

      // if (formData.language_skills.length === 0) {
      //   await Swal.fire({
      //     title: 'Error!',
      //     text: 'Please select at least one language skill',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#d33',
      //   });
      //   return false;
      // }

      // // Prometric certificate validation
      // if (formData.has_prometric_certificate === null || formData.has_prometric_certificate === undefined || formData.has_prometric_certificate === '') {
      //   await Swal.fire({
      //     title: 'Error!',
      //     text: 'Please select if you have a Prometric certificate',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#d33',
      //   });
      //   return false;
      // }

      // // Dataflow certificate validation
      // if (formData.has_dataflow_certificate === null || formData.has_dataflow_certificate === undefined || formData.has_dataflow_certificate === '') {
      //   await Swal.fire({
      //     title: 'Error!',
      //     text: 'Please select if you have a Dataflow certificate',
      //     icon: 'error',
      //     confirmButtonText: 'OK',
      //     confirmButtonColor: '#d33',
      //   });
      //   return false;
      // }

      // if (formData.has_nursing_license !== false) {
      //   if (formData.nursing_license_countries.length === 0 && !formData.other_nursing_license_country) {
      //     await Swal.fire({
      //       title: 'Error!',
      //       text: 'Please select or specify at least one nursing license country, or check "Don\'t Have License"',
      //       icon: 'error',
      //       confirmButtonText: 'OK',
      //       confirmButtonColor: '#d33',
      //     });
      //     return false;
      //   }
      // }
    }

    if (isHealthcareProfileSelected && isHospitalOrHealthcareCategory) {
      if (formData.nursing_license_countries.length === 0 && !formData.other_nursing_license_country) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select or specify at least one nursing license country',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    // Tailor-specific validations
    if (isTailorSelected) {
      if (!formData.tailor_mode) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select a tailor mode',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.tailor_type) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select a tailor type/specialization',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.stitching_preferences || formData.stitching_preferences.length === 0) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select at least one stitching preference',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    // Beautician-specific validations
    if (isBeauticianSelected) {
      if (!formData.beautician_mode) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select a beautician mode',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }

      if (!formData.beautician_type) {
        await Swal.fire({
          title: 'Error!',
          text: 'Please select a beautician type/specialization',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleNext = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();

      // Scroll to top and then navigate after a small delay
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });

      // Small delay to ensure scroll happens
      setTimeout(() => {
        navigate('/a-preference', {
          state: {
            userId,
            current_country,
            job_position: formData.job_position
          }
        });
      }, 100);
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleBack = () => {
    window.scrollTo(0, 0);
    navigate('/a-contactdetails', { state: { userId, userName } });
  };

  // Categories - Updated to match second code
  const categories = PROFESSIONAL_INFO_CATEGORIES;

  const banReasons = ["BROKEN CONTRACT", "RAN AWAY", "DEPORTATION", "OVER STAY", "MEDICAL ISSUE", "CRIMINAL RECORD", "OTHER"];
  const jobTypes = ["Full Time", "Part Time", "Temporary", "Permanent", "Fresher", "Freelance"];
  const workStatuses = [
    "Finished contract", "Terminated (relocation / financial)", "Terminated (Other)",
    "Broken contract", "Transfered", "Working in home country", "Unemployed", "Ex-oversea",
    "Better Opportunities", "Better Salary", "Job Security", "Personal Reasons"
  ];
  const visaTypes = [
    "Looking for visa", // Move this to the top
    "I have Work Visa",
    "Visit visa",
    "Family Visa",
    "Visa Transfer",
    "Need Family Visa",
    "Transfer visa",
    "Husband visa",
    "To be Cancelled visa",
    "Own Visa",
    "Cancelled Visa",
    "Work visa"
  ];
  const countries = [
    "Qatar", "Dubai", "Oman", "Saudi", "Kuwait", "Bahrain", "EU Driving Licence", "Singapore",
    "UAE", "Turkey", "Malaysia", "Taiwan", "South Korea", "Hongkong", "Russia",
    "Jordan", "Israel", "USA", "UK", "Canada", "Australia", "India", "Philippines",
    "Saudi Arabia", "Brunei", "Hong Kong", "Japan", "Germany", "Netherlands",
    "United Kingdom", "Italy", "Spain", "France", "Poland", "Portugal", "Romania",
    "Hungary", "United States", "New Zealand", "Bangladesh", "Nepal", "Sri Lanka",
    "Pakistan", "Indonesia", "Myanmar", "Vietnam", "Cambodia", "Thailand",
    "Ethiopia", "Kenya", "Uganda", "Tanzania", "Rwanda", "Ghana", "Nigeria",
    "Sierra Leone", "Burundi", "Cameroon", "Maldives",
    "Home Country Licence", "International Driving Permit"
];

  // CNC Operator Options
  const cncOperatorPositions = [
    "CNC Operator – Turning", "CNC Operator – Milling", "VMC Operator",
    "HMC Operator", "5-Axis Operator", "CNC Machine Setter"
  ];
  const cncOperatorIndustries = [
    "Manufacturing", "Automotive", "Oil & Gas",
    "Aerospace", "Metal Fabrication", "Other"
  ];
  const cncOperatorControlsList = [
    "FANUC", "Siemens", "Heidenhain", "Mitsubishi",
    "Haas", "Mazak", "Okuma", "Other"
  ];
  const cncOperatorMachinesList = [
    "CNC Lathe", "CNC Milling", "VMC", "HMC", "5-Axis", "Swiss Type"
  ];
  const cncOperatorTechnicalSkills = [
    "Tool Setting", "Offset Setting", "Tool Change",
    "Reading Engineering Drawings", "Basic G-Code Understanding",
    "Quality Inspection (Vernier / Micrometer)", "Basic Maintenance",
    "Production Target Handling"
  ];
  const cncOperatorSoftwareKnowledge = [
    "Mastercam", "SolidCAM", "UG NX", "Fusion 360", "None"
  ];

  const allWorldCountries = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
    "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
    "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad",
    "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
    "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",
    "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala",
    "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia",
    "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan",
    "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
    "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
    "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",
    "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",
    "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
    "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
    "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",
    "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
    "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan",
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
    "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
    "Ukraine", "Dubai (UAE)", "UAE", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",
    "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
  ];
  const nursingQualifications = [
    "ANM", "GNM", "Certificate in Nursing", "Diploma in Nursing",
    "Diploma in Physiotherapy", "Bachelor (BPT)", "Master (MPT)",
    "BSc Nursing", "Post Basic BSc Nursing", "BSN", "MSc Nursing",
    "MSN", "MPhil in Nursing", "PhD in Nursing", "DNP",
    "DNS", "Doctoral Degree", "Post-Doctoral Certificate", "Postdoctoral Fellowship",
    "ADN", "Other"
  ];
  const professionalQualifications = [
    "Registered Nurse", "Certified Nurse Practitioner", "Certified Midwife", "Certified Registered Nurse Anesthetist",
    "Certified Nurse Specialist", "Advanced Practice Registered Nurse", "Neonatal Intensive Care Unit", "Critical Care Registered Nurse",
    "Emergency Nursing", "Operating Room Nursing", "Pediatric Advanced Life Support", "Basic Life Support",
    "Orthopedic Nurse", "Wound, Ostomy, and Continence", "Other"
  ];
  const specializedQualifications = [
    "Critical Care Registered Nurse", "Emergency Nursing Certification", "Certified Nurse Operating Room", "Neonatal Intensive Care Unit Certification",
    "Pediatric Intensive Care Unit Certification", "Intensive Care Unit Certification", "Emergency Room Certification", "Operating Room Certification",
    "Pediatric Advanced Life Support", "Neonatal Resuscitation Program Certification", "Wound, Ostomy, and Continence Certification", "Orthopedic Nurse Certification",
    "Certified Nurse Practitioner", "Certified Registered Nurse Anesthetist", "Certified Midwife", "Other"
  ];
  const languageQualifications = [
    "TOEFL", "IELTS", "ESL", "Multilingual Certification"
  ];
  const culturalAdaptationQualifications = [
    "Transcultural Nursing", "Cultural Competence", "Diversity and Inclusion", "Global Health"
  ];

  const countryOptions = [
    "Saudi Arabia", "United Arab Emirates", "Qatar", "Kuwait", "Oman", "Bahrain",
    "United Kingdom", "Germany", "France", "Italy", "Spain", "Poland", "Romania",
    "Netherlands", "Belgium", "Greece", "Portugal", "Sweden", "Hungary", "Austria",
    "Switzerland", "Serbia", "Bulgaria", "Denmark", "Finland", "Slovakia", "Norway",
    "Ireland", "Croatia", "Moldova", "Bosnia and Herzegovina", "Albania", "Lithuania",
    "North Macedonia", "Slovenia", "Latvia", "Estonia", "Luxembourg", "Malta", "Iceland"
  ];
  const industryExperiences = ["Manufacturing", "Oil & Gas", "Aerospace", "Automotive", "Other"];
  const cncControlsList = ["FANUC", "Siemens", "Heidenhain", "Mitsubishi", "Mazak", "Haas", "OKUMA", "Other"];
  const cncMachinesList = ["CNC Turning (Lathe)", "CNC Milling", "VMC", "HMC", "5-Axis", "Swiss Type", "Other"];
  const programmingTypes = ["Manual G-Code", "Macro Programming", "Conversational"];
  const cadCamList = ["Mastercam", "SolidCAM", "UG NX", "Fusion 360", "PowerMill", "SolidWorks", "Other"];
  const yesNoOptions = ["Yes", "No"];
  const gdtKnowledgeOptions = ["Basic", "Good", "Expert"];
  const jobSkillsList = [
    "Cycle Time Optimization", "Process Planning", "Tool Selection & Tool Life Control",
    "Fixture / Jigs Knowledge", "Quality inspection (Vernier/Micrometer/Bore Gauge)",
    "CMM Knowledge", "ISO Standards / Tolerances"
  ];

  // Mechanic Options
  const mechanicWorkedWith = [
    "Garage", "Dealership", "Company Fleet",
    "Transport Company", "Construction Company", "other"
  ];

  const mechanicSkillsList = [
    "Engine Overhauling", "Transmission Repair", "Brake System Repair",
    "Suspension Repair", "Steering System", "Electrical Wiring",
    "Battery / Alternator Repair", "AC Repair", "Diagnostic Scanner Use",
    "ECU Troubleshooting", "Truck Engine Repair", "Bus Repair",
    "Trailer Maintenance", "Hydraulic System Repair", "Gearbox Repair",
    "Differential Repair", "Air Brake System", "Diesel Injection System",
    "Turbo Repair", "Crane / Excavator Maintenance"
  ];

  const mechanicVehicleExperienceList = [
    "Toyota", "Nissan", "Mitsubishi", "Ford", "Mercedes", "Volvo", "MAN",
    "Scania", "Caterpillar", "Komatsu", "Other"
  ];

  const mechanicDrivingLicenseOptions = [
    "Light", "Heavy", "Both", "None"
  ];

  const nursingJobCountries = [
    // First 8 countries for button display
    "Qatar", "Dubai", "Bahrain", "Saudi",
    "Germany", "UK", "Ireland", "Canada",

    // Rest of the countries (alphabetical)
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola",
    "Antigua and Barbuda", "Argentina", "Armenia", "Australia",
    "Austria", "Azerbaijan", "Bahamas", "Bangladesh", "Barbados",
    "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
    "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
    "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde",
    "Cambodia", "Cameroon", "Canada", "Central African Republic",
    "Chad", "Chile", "China", "Colombia", "Comoros",
    "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia",
    "Cuba", "Cyprus", "Czech Republic (Czechia)",
    "Democratic Republic of the Congo", "Denmark", "Djibouti",
    "Dominica", "Dominican Republic", "East Timor (Timor-Leste)",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea",
    "Eritrea", "Estonia", "Eswatini (fmr. Swaziland)",
    "Ethiopia", "Fiji", "Finland", "France", "Gabon",
    "Gambia", "Georgia", "Germany", "Ghana", "Greece",
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
    "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland",
    "India", "Indonesia", "Iran", "Iraq", "Ireland",
    "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan",
    "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North",
    "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia",
    "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali",
    "Malta", "Marshall Islands", "Mauritania", "Mauritius",
    "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",
    "Montenegro", "Morocco", "Mozambique", "Myanmar (Burma)",
    "Namibia", "Nauru", "Nepal", "Netherlands",
    "New Zealand", "Nicaragua", "Niger", "Nigeria",
    "North Macedonia", "Norway", "Oman", "Pakistan",
    "Palau", "Palestine", "Panama", "Papua New Guinea",
    "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
    "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
    "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa",
    "San Marino", "Sao Tome and Principe", "Saudi Arabia",
    "Senegal", "Serbia", "Seychelles", "Sierra Leone",
    "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
    "Somalia", "South Africa", "South Korea", "South Sudan",
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden",
    "Switzerland", "Syria", "Taiwan", "Tajikistan",
    "Tanzania", "Thailand", "Togo", "Tonga",
    "Trinidad and Tobago", "Tunisia", "Turkey",
    "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
    "United Arab Emirates (UAE)", "United Kingdom (UK)",
    "United States of America (USA)", "Uruguay", "Uzbekistan",
    "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
    "Yemen", "Zambia", "Zimbabwe", "Any Country"
  ];
  const languageSkills = [
    "English", "Arabic", "Nepali", "Srilankan", "Thai", "Macanese", "India", "Japanese",
    "Russian", "Bangali", "Cantonese", "Vietnamese", "Mandarin", "Combodian", "Iranian", "Korean",
    "Indonesia (Bahasa)", "Filipino (Tagalog)", "African", "Other"
  ];

  const nursingLicenseCountries = [
    "Qatar - QCHP / DHP",
    "UAE - DHA / DOH / MOH",
    "Saudi Arabia - SCFHS",
    "Oman - MOH License",
    "Kuwait - MOH License",
    "Bahrain - NHRA",
    "Applied",
    "In Progress",
    "Eligible",
    "UK - NMC Registration",
    "Germany - Nursing License",
    "Ireland - NMBI",
    "Netherlands - BIG Register",
    "France - Nursing License",
    "Italy - Nursing License",
    "Not Licensed",
    "Spain - Nursing License",
    "Belgium - Nursing License",
    "Norway / Sweden - Nursing License",
    "Poland - Nursing License",
    "Romania - Nursing License",
    "Croatia - Nursing License",
    "Singapore - SNB License",
    "Malaysia - Nursing Board",
    "Hong Kong - Nursing Council",
    "Japan - Nursing License",
    "South Korea - Nursing License",
    "USA - NCLEX-RN",
    "Canada - NCLEX / Provincial License",
    "Australia - AHPRA",
    "New Zealand - Nursing Council"
  ];

  const nursingPositions = [
    "Registered Nurse", "Licensed Practical Nurse", "Certified Nursing Assistant",
    "Advanced Practice Registered Nurse", "Nurse Practitioner", "Nurse Educator",
    "Nurse Researcher", "Nurse Administrator", "Critical Care Nurse",
    "Specialty Nurse", "Staff Nurse", "ICU Nurse", "OR Nurse", "ER Nurse",
    "Maternal Child Nurse", "Oncology Nurse", "Certified Nurse Midwife",
    "CNS", "Charge Nurse", "Nurse Manager", "Director of Nursing",
    "CNO", "Travel Nurse", "Telehealth Nurse"
  ];

  return (
    <>
      <AgencyNavbar />
      <div className="professional-wrapper" style={{ marginTop: "84px", width: '96%', marginLeft: '2%' }}>
        <Container className="mt-4 px-4 pb-5">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <Card className="shadow border-0 professional-info-card">
            <Card.Header className="professional-info-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-person-badge me-2"></i>
                Professional Information
              </h2>
            </Card.Header>
            <Card.Body className="professional-info-body">
              <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Select Job category</h4>
              <div className="mb-3">
                <Form.Select
                  value={formData.category || ""}
                  onChange={(e) => updateField("category", e.target.value)}
                  className="py-3"
                >
                  <option value="">Select Job category</option>
                  {categories.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {formData.category && (
                <>
                  <h4 className="mb-3 fw-semibold text-dark fields-headingfont">
                    <div className="d-flex flex-row align-items-start align-items-md-center">
                      <div>Select job position *</div>
                    </div>
                  </h4>

                  <div className="mb-4">
                    <CustomDropdown
                      title="Select Job Position"
                      field="job_position_dropdown"
                      options={getFilteredJobPositions().map(pos => pos.position)}
                      selectedValue={formData.job_position[0] || ""}
                      onSelect={(field, position) => {
                        togglePosition(position);
                      }}
                      required={true}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>

                  {formData.category === HOSPITALITY_CATEGORY && (formData.job_position || []).some((position) => HOSPITALITY_POSITIONS.includes(position)) && (
                    <div className="mb-5">
                      <h4 className="mb-3 fw-semibold text-dark fields-headingfont">
                        Experience Type <span style={{ fontWeight: 400 }}>(Select one or more)</span>
                      </h4>
                      <Row className="g-3">
                        {HOSPITALITY_EXPERIENCE_TYPES.map((type) => (
                          <Col xs={12} sm={6} md={3} key={type}>
                            <Button
                              variant="light"
                              className={`language-btn jobtype-btn w-100 ${(formData.hospitality_experience_types || []).includes(type) ? 'selected-button' : ''}`}
                              onClick={() => toggleHospitalityExperienceType(type)}
                            >
                              {type}
                            </Button>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}

                  {formData.category === SOFTWARE_IT_CATEGORY && (formData.job_position || []).some((position) => SOFTWARE_IT_POSITIONS.includes(position)) && (
                    <div className="mb-5">
                      <h4 className="mb-3 fw-semibold text-dark fields-headingfont">
                        Technical Skills <span style={{ fontWeight: 400 }}>(Select all that apply)</span>
                      </h4>

                      <div className="mb-4">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Programming Languages</h5>
                        <Row className="g-3">
                          {SOFTWARE_IT_PROGRAMMING_LANGUAGES.map((skill) => (
                            <Col xs={6} md={3} key={skill}>
                              <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${(formData.software_it_programming_languages || []).includes(skill) ? 'selected-button' : ''}`}
                                onClick={() => toggleSoftwareItSelection('software_it_programming_languages', skill)}
                              >
                                {skill}
                              </Button>
                            </Col>
                          ))}
                          <Col xs={12} md={3}>
                            <Form.Control
                              type="text"
                              placeholder="Other"
                              className="professional-input"
                              value={formData.software_it_other_programming_language || ''}
                              onChange={(e) => updateField('software_it_other_programming_language', e.target.value)}
                            />
                          </Col>
                        </Row>
                      </div>

                      <div className="mb-4">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Frameworks / Technologies</h5>
                        <Row className="g-3">
                          {SOFTWARE_IT_FRAMEWORKS.map((skill) => (
                            <Col xs={6} md={3} key={skill}>
                              <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${(formData.software_it_frameworks || []).includes(skill) ? 'selected-button' : ''}`}
                                onClick={() => toggleSoftwareItSelection('software_it_frameworks', skill)}
                              >
                                {skill}
                              </Button>
                            </Col>
                          ))}
                        </Row>
                      </div>

                      <div className="mb-4">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Database Skills</h5>
                        <Row className="g-3">
                          {SOFTWARE_IT_DATABASE_SKILLS.map((skill) => (
                            <Col xs={6} md={3} key={skill}>
                              <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${(formData.software_it_database_skills || []).includes(skill) ? 'selected-button' : ''}`}
                                onClick={() => toggleSoftwareItSelection('software_it_database_skills', skill)}
                              >
                                {skill}
                              </Button>
                            </Col>
                          ))}
                        </Row>
                      </div>

                      <div className="mb-4">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Other Skills</h5>
                        <Row className="g-3">
                          {SOFTWARE_IT_OTHER_SKILLS.map((skill) => (
                            <Col xs={6} md={3} key={skill}>
                              <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${(formData.software_it_other_skills || []).includes(skill) ? 'selected-button' : ''}`}
                                onClick={() => toggleSoftwareItSelection('software_it_other_skills', skill)}
                              >
                                {skill}
                              </Button>
                            </Col>
                          ))}
                        </Row>
                      </div>

                      <div className="mb-4">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Certifications (if any)</h5>
                        <Row className="g-3">
                          {SOFTWARE_IT_CERTIFICATIONS.map((cert) => (
                            <Col xs={6} md={3} key={cert}>
                              <Button
                                variant="light"
                                className={`language-btn jobtype-btn w-100 ${(formData.software_it_certifications || []).includes(cert) ? 'selected-button' : ''}`}
                                onClick={() => toggleSoftwareItSelection('software_it_certifications', cert)}
                              >
                                {cert}
                              </Button>
                            </Col>
                          ))}
                          <Col xs={12} md={3}>
                            <Form.Control
                              type="text"
                              placeholder="Other"
                              className="professional-input"
                              value={formData.software_it_other_certification || ''}
                              onChange={(e) => updateField('software_it_other_certification', e.target.value)}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}



                </>
              )}

              {isDriverSelected && (
                <>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      Which country Driving license do you have?*
                    </h4>

                    {/* Display first 4 countries as buttons */}
                    <Row className="g-3 mb-3">
                      {countries.slice(0, 4).map((country, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`license-btn driver-options w-100 ${formData.driving_license_country.includes(country) ? 'selected-button' : ''}`}
                            onClick={() => toggleLicenseCountry(country)}
                            disabled={formData.driving_license_country.length >= 3 && !formData.driving_license_country.includes(country)}
                          >
                            {country}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining countries */}
                    {countries.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other license country"
                          field="driving_license_country_dropdown"
                          options={countries.slice(4)}
                          selectedValue={formData.driving_license_country.find(country =>
                            countries.slice(4).includes(country)
                          ) || ""}
                          onSelect={(field, country) => {
                            toggleLicenseCountry(country);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                        />
                      </div>
                    )}

                    <p className="note-text mb-3"><strong>You can select up to 3 countries</strong></p>

                    <Form.Control
                      type="text"
                      placeholder="Type any other country name"
                      className="professional-input mt-3"
                      value={formData.other_driving_license_country ?? ''}
                      onChange={(e) => updateField('other_driving_license_country', e.target.value)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      What Kind of Car you have drive?*
                    </h4>

                    {/* Display first 4 car types as buttons */}
                    <Row className="g-3 mb-3">
                      {['Manual', 'Semi Automatic', 'Fully Automatic', 'Continuously Variable'].map((type, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`car-type-btn driver-options w-100 ${formData.car_type.includes(type) ? 'selected-button' : ''}`}
                            onClick={() => toggleCarType(type)}
                            disabled={formData.car_type.length >= 3 && !formData.car_type.includes(type)}
                          >
                            {type}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining car types */}
                    {['Dual Clutch', 'Automated Manual', 'Tiptronic', 'Paddle Shift', 'Sequential Manual', 'Epicyclic'].length > 0 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other car type"
                          field="car_type_dropdown"
                          options={['Dual Clutch', 'Automated Manual', 'Tiptronic', 'Paddle Shift', 'Sequential Manual', 'Epicyclic']}
                          selectedValue={formData.car_type.find(type =>
                            ['Dual Clutch', 'Automated Manual', 'Tiptronic', 'Paddle Shift', 'Sequential Manual', 'Epicyclic'].includes(type)
                          ) || ""}
                          onSelect={(field, type) => {
                            toggleCarType(type);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                        />
                      </div>
                    )}

                    <p className="note-text"><strong>You can select up to 3 car types</strong></p>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      What is the car name you have driven before?*
                    </h4>

                    {/* Display first 4 cars as buttons */}
                    <Row className="g-3 mb-3">
                      {['Land Cruiser', 'Nissan Patrol', 'Toyota Camry', 'Honda Accord'].map((car, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`car-name-btn driver-options w-100 ${formData.previous_car.includes(car) ? 'selected-button' : ''}`}
                            onClick={() => togglePreviousCar(car)}
                            disabled={formData.previous_car.length >= 3 && !formData.previous_car.includes(car)}
                          >
                            {car}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining cars */}
                    <div className="mb-3">
                      <CustomDropdown
                        title="Select other car"
                        field="previous_car_dropdown"
                        options={['Land Rover', 'Mercedes', 'BMW', 'Audi', 'Porsche Cayenne', 'Range Rover', 'Ford', 'Chevrolet Silverado', 'Dodge Ram', 'GMC Sierra', 'Lexus LX', 'Jeep Wrangler', 'Enova', 'Pickup']}
                        selectedValue={formData.previous_car.find(car =>
                          ['Land Rover', 'Mercedes', 'BMW', 'Audi', 'Porsche Cayenne', 'Range Rover', 'Ford', 'Chevrolet Silverado', 'Dodge Ram', 'GMC Sierra', 'Lexus LX', 'Jeep Wrangler', 'Enova', 'Pickup'].includes(car)
                        ) || ""}
                        onSelect={(field, car) => {
                          togglePreviousCar(car);
                        }}
                        required={false}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </div>

                    <p className="note-text mb-3"><strong>You can select up to 3 cars</strong></p>

                    <Form.Control
                      type="text"
                      placeholder="Type any other car"
                      className="professional-input mt-3"
                      value={formData.other_previous_car ?? ''}
                      onChange={(e) => updateField('other_previous_car', e.target.value)}
                    />
                  </div>
                </>
              )}

              {isHealthcareProfileSelected && (
                <>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Which hospital do you currently work at?</h4>
                    <Row className="g-3 mb-3">
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-4">
                          <Form.Control
                            type="text"
                            placeholder="Type current hospital name"
                            className="professional-input"
                            value={formData.current_hospital_name ?? ''}
                            onChange={(e) => updateField('current_hospital_name', e.target.value)}
                          // Removed the required attribute
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group style={{ marginTop: "-20px" }}>
                          <CustomDropdown
                            title="Select Country"
                            field="current_hospital_country"
                            options={countries}
                            selectedValue={formData.current_hospital_country}
                            onSelect={updateField}
                            // Removed required={true}
                            menuClassName="personalinfo-nationality-menu"
                            allowClear={true}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="g-3 mt-3">
                      <Col xs={12} md={6}>
                        <h4 className='fields-headingfont'>Employment Date</h4>
                        <DatePicker
                          selected={formData.current_employment_date}
                          onChange={(date) => updateField('current_employment_date', date)}
                          className="date-picker-input"
                          placeholderText="Select employment date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={20}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <h4 className="finish-contract fields-headingfont">Finish Contract Date</h4>
                        <DatePicker
                          selected={formData.current_finish_contract_date}
                          onChange={(date) => updateField('current_finish_contract_date', date)}
                          className="date-picker-input"
                          placeholderText="Select finish contract date"
                          minDate={formData.current_employment_date || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={20}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Previous Hospital Name</h4>
                    <Row className="g-3 mb-3">
                      <Col xs={12} md={6}>
                        <Form.Group className="mb-4">
                          <Form.Control
                            type="text"
                            placeholder="Type your previous hospital name"
                            className="professional-input"
                            value={formData.previous_hospital_name ?? ''}
                            onChange={(e) => updateField('previous_hospital_name', e.target.value)}
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} md={6}>
                        <Form.Group className="mb-4" style={{ marginTop: "-20px" }}>
                          <CustomDropdown
                            title="Select Other"
                            field="previous_hospital_country"
                            options={countries}
                            selectedValue={formData.previous_hospital_country}
                            onSelect={updateField}
                            menuClassName="personalinfo-nationality-menu"
                            allowClear={true}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="g-3 mt-3">
                      <Col xs={12} md={6}>
                        <h4 className='fields-headingfont'>Employment Date</h4>
                        <DatePicker
                          selected={formData.previous_employment_date}
                          onChange={(date) => updateField('previous_employment_date', date)}
                          className="date-picker-input"
                          placeholderText="Select employment date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={20}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <h4 className="finish-contract fields-headingfont">Finish Contract Date</h4>
                        <DatePicker
                          selected={formData.previous_finish_contract_date}
                          onChange={(date) => updateField('previous_finish_contract_date', date)}
                          className="date-picker-input"
                          placeholderText="Select finish contract date"
                          minDate={formData.previous_employment_date || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={20}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      Nursing Academic Qualifications
                    </h4>

                    {/* Display first 4 qualifications as buttons */}
                    <Row className="g-3 mb-3">
                      {nursingQualifications.slice(0, 4).map((qualification, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn qualification-btn w-100 ${formData.nursing_qualifications.includes(qualification) ? 'selected-button' : ''}`}
                            onClick={() => toggleNursingQualification(qualification)}
                          >
                            {qualification}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining qualifications */}
                    {nursingQualifications.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other nursing qualification"
                          field="nursing_qualification_dropdown"
                          options={nursingQualifications.slice(4)}
                          selectedValue={formData.nursing_qualifications.find(qual =>
                            nursingQualifications.slice(4).includes(qual)
                          ) || ""}
                          onSelect={(field, qualification) => {
                            toggleNursingQualification(qualification);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          allowClear={true}
                          isMultiSelect={true} // Add this line
                        />
                      </div>
                    )}
                  </div>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      Professional Qualifications
                    </h4>

                    {/* Display first 4 qualifications as buttons */}
                    <Row className="g-3 mb-3">
                      {professionalQualifications.slice(0, 4).map((qualification, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn qualification-btn w-100 ${formData.professional_qualifications.includes(qualification) ? 'selected-button' : ''}`}
                            onClick={() => toggleProfessionalQualification(qualification)}
                          >
                            {qualification}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining qualifications */}
                    {professionalQualifications.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other professional qualification"
                          field="professional_qualification_dropdown"
                          options={professionalQualifications.slice(4)}
                          selectedValue={formData.professional_qualifications.find(qual =>
                            professionalQualifications.slice(4).includes(qual)
                          ) || ""}
                          onSelect={(field, qualification) => {
                            toggleProfessionalQualification(qualification);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          allowClear={true}
                          isMultiSelect={true} // Add this line
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      Specialized Qualifications
                    </h4>

                    {/* Display first 3 qualifications as buttons */}
                    <Row className="g-3 mb-3">
                      {specializedQualifications.slice(0, 3).map((qualification, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn qualification-btn w-100 ${formData.specialized_qualifications.includes(qualification) ? 'selected-button' : ''}`}
                            onClick={() => toggleSpecializedQualification(qualification)}
                          >
                            {qualification}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining qualifications */}
                    {specializedQualifications.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other specialized qualification"
                          field="specialized_qualification_dropdown"
                          options={specializedQualifications.slice(4)}
                          selectedValue={formData.specialized_qualifications.find(qual =>
                            specializedQualifications.slice(4).includes(qual)
                          ) || ""}
                          onSelect={(field, qualification) => {
                            toggleSpecializedQualification(qualification);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          allowClear={true}
                          isMultiSelect={true} // Add this line
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Language Qualifications</h4>
                    <Row className="g-3">
                      {languageQualifications.map((qualification, idx) => (
                        <Col xs={6} sm={6} md={4} lg={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn qualification-btn w-100 ${formData.language_qualifications.includes(qualification) ? 'selected-button' : ''}`}
                            onClick={() => toggleLanguageQualification(qualification)}
                          >
                            {qualification}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Cultural Adaptation Qualifications</h4>
                    <Row className="g-3">
                      {culturalAdaptationQualifications.map((qualification, idx) => (
                        <Col xs={6} sm={6} md={4} lg={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn qualification-btn w-100 ${formData.cultural_adaptation_qualifications.includes(qualification) ? 'selected-button' : ''}`}
                            onClick={() => toggleCulturalAdaptationQualification(qualification)}
                          >
                            {qualification}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Do you have Prometric certificate?</h4>
                    <Row className="mb-3">
                      <Col xs={6}>
                        <Button
                          className={`option-btn w-100 ${formData.has_prometric_certificate === true ? 'selected-button' : ''}`}
                          onClick={() => updateField('has_prometric_certificate', true)}
                        >
                          Yes
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button
                          className={`option-btn w-100 ${formData.has_prometric_certificate === false ? 'selected-button' : ''}`}
                          onClick={() => updateField('has_prometric_certificate', false)}
                        >
                          No
                        </Button>
                      </Col>
                    </Row>

                    {formData.has_prometric_certificate === true || formData.has_prometric_certificate === 'Applied' ? (
                      <Row className="g-2 mt-3">
                        <Col xs={4}>
                          <h5 className='text-left fields-headingfont'>Issue Date</h5>
                          <DatePicker
                            selected={formData.prometric_issue_date}
                            onChange={(date) => updateField('prometric_issue_date', date)}
                            className="date-picker-input-nurse"
                            placeholderText="Select issue date"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            dateFormat="MM/dd/yyyy"
                            autoFocus={false}
                          />
                        </Col>
                        <Col xs={4}>
                          <h5 className='fields-headingfont text-left'>Expiry Date</h5>
                          <DatePicker
                            selected={formData.prometric_expiry_date}
                            onChange={(date) => updateField('prometric_expiry_date', date)}
                            className="date-picker-input-nurse"
                            placeholderText="Select expiry date"
                            minDate={formData.prometric_issue_date || new Date()}
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            dateFormat="MM/dd/yyyy"
                            autoFocus={false}
                          />
                        </Col>
                        <Col xs={4}>
                          <h5 className='text-left fields-headingfont'>Issued Country</h5>
                          <Form.Select
                            className="professional-input"
                            value={formData.prometric_issued_country ?? ''}
                            onChange={(e) => updateField('prometric_issued_country', e.target.value)}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country, idx) => (
                              <option key={idx} value={country}>{country}</option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Row>
                    ) : null}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Do you have Dataflow certificate?</h4>
                    <Row className="mb-3">
                      <Col xs={6}>
                        <Button
                          className={`option-btn w-100 ${formData.has_dataflow_certificate === true ? 'selected-button' : ''}`}
                          onClick={() => updateField('has_dataflow_certificate', true)}
                        >
                          Yes
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <Button
                          className={`option-btn w-100 ${formData.has_dataflow_certificate === false ? 'selected-button' : ''}`}
                          onClick={() => updateField('has_dataflow_certificate', false)}
                        >
                          No
                        </Button>
                      </Col>
                    </Row>

                    {formData.has_dataflow_certificate === true || formData.has_dataflow_certificate === 'Applied' ? (
                      <Row className="g-2 mt-3">
                        <Col xs={4}>
                          <h5 className='text-left fields-headingfont'>Issue Date</h5>
                          <DatePicker
                            selected={formData.dataflow_issue_date}
                            onChange={(date) => updateField('dataflow_issue_date', date)}
                            className="date-picker-input-nurse"
                            placeholderText="Select issue date"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            dateFormat="MM/dd/yyyy"
                            autoFocus={false}
                          />
                        </Col>
                        <Col xs={4}>
                          <h5 className='fields-headingfont text-left'>Expiry Date</h5>
                          <DatePicker
                            selected={formData.dataflow_expiry_date}
                            onChange={(date) => updateField('dataflow_expiry_date', date)}
                            className="date-picker-input-nurse"
                            placeholderText="Select expiry date"
                            minDate={formData.dataflow_issue_date || new Date()}
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            dateFormat="MM/dd/yyyy"
                            autoFocus={false}
                          />
                        </Col>
                        <Col xs={4}>
                          <h5 className='fields-headingfont'>Issued Country</h5>
                          <Form.Select
                            className="professional-input"
                            value={formData.dataflow_issued_country ?? ''}
                            onChange={(e) => updateField('dataflow_issued_country', e.target.value)}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country, idx) => (
                              <option key={idx} value={country}>{country}</option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Row>
                    ) : null}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      Which Country Nursing License do you have?
                      {isHospitalOrHealthcareCategory && <span className="text-danger ms-1">*</span>}
                    </h4>

                    {/* Display first 4 countries as buttons */}
                    <Row className="g-3 mb-3">
                      {nursingLicenseCountries.slice(0, 4).map((country, idx) => (
                        <Col xs={6} sm={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.nursing_license_countries.includes(country) ? 'selected-button' : ''}`}
                            onClick={() => toggleNursingLicenseCountry(country)}
                          >
                            {country}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining countries */}
                    {nursingLicenseCountries.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other nursing license country"
                          field="nursing_license_country_dropdown"
                          options={nursingLicenseCountries.slice(4)}
                          selectedValue={formData.nursing_license_countries.find(country =>
                            nursingLicenseCountries.slice(4).includes(country)
                          ) || ""}
                          onSelect={(field, country) => {
                            toggleNursingLicenseCountry(country);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          allowClear={true}
                          isMultiSelect={true} // Add this line
                        />
                      </div>
                    )}

                    <div className="mt-3">
                      <Form.Control
                        type="text"
                        placeholder="Issued a nursing license in any other country? (Type here)"
                        className="professional-input"
                        value={formData.other_nursing_license_country ?? ''}
                        onChange={(e) => updateField('other_nursing_license_country', e.target.value)}
                      />
                    </div>

                    <Row className="g-3 mt-3">
                      <Col xs={12} md={6}>
                        <h5 className="fields-headingfont text-left">License Issue Date</h5>
                        <DatePicker
                          selected={formData.nursing_license_issue_date}
                          onChange={(date) => updateField('nursing_license_issue_date', date)}
                          className="date-picker-input"
                          placeholderText="Select issue date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={30}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <h5 className='fields-headingfont text-left'>License Expiry Date</h5>
                        <DatePicker
                          selected={formData.nursing_license_expiry_date}
                          onChange={(date) => updateField('nursing_license_expiry_date', date)}
                          className="date-picker-input"
                          placeholderText="Select expiry date"
                          minDate={formData.nursing_license_issue_date || new Date()}
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={30}
                          scrollableYearDropdown
                          dateFormat="MM/dd/yyyy"
                          autoFocus={false}
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      How many children do you have?
                    </h4>

                    <CustomDropdown
                      title="Select number of children"
                      field="no_of_children"
                      options={['1', '2', '3', '4', '5']}
                      selectedValue={formData.no_of_children || ''}
                      onSelect={(field, value) => {
                        updateField(field, value);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                    />

                    {formData.no_of_children && !['1', '2', '3', '4', '5'].includes(formData.no_of_children.toString()) && (
                      <div className="mt-2">
                        <Form.Control
                          type="text"
                          placeholder="Enter number of children"
                          className="professional-input"
                          value={formData.no_of_children ?? ''}
                          onChange={(e) => updateField('no_of_children', e.target.value)}
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>
                      For which position, do you want to apply?*
                    </h4>

                    {/* Display first 3 positions as buttons */}
                    <Row className="g-3 mb-3">
                      {nursingPositions.slice(0, 3).map((position, idx) => (
                        <Col xs={6} sm={4} md={4} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.nursing_positions.includes(position) ? 'selected-button' : ''}`}
                            onClick={() => toggleNursingPosition(position)}
                          >
                            {position}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {/* Dropdown for remaining positions */}
                    {nursingPositions.length > 4 && (
                      <div className="mb-3">
                        <CustomDropdown
                          title="Select other nursing position"
                          field="nursing_position_dropdown"
                          options={nursingPositions.slice(4)}
                          selectedValue={formData.nursing_positions.find(position =>
                            nursingPositions.slice(4).includes(position)
                          ) || ""}
                          onSelect={(field, position) => {
                            toggleNursingPosition(position);
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          allowClear={true}
                          isMultiSelect={true} // Add this line
                        />
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* Tailor-specific fields */}
              {isTailorSelected && (
                <TailorFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {/* Beautician-specific fields */}
              {isBeauticianSelected && (
                <BeauticianFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {isTeacherSelected && (
                <TeacherFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {/* Welder-specific fields */}
              {isWelderSelected && (
                <AgencyWelderFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {/* Fabricator and Pipe Fitter Component Rendering */}
              {(isFabricatorSelected || isPipeFitterSelected) && (
                <AgencyFabricatorPipeFitterFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {/* AC and HVAC Technician Component Rendering */}
              {(isACTechnicianSelected || isHVACTechnicianSelected) && (
                <AgencyACTechnicianFields
                  formData={formData}
                  setFormData={setFormData}
                />
              )}

              {/* Chiller Technician Component Rendering */}
              {isChillerTechnicianSelected && (
                <AgencyChillerTechnicianFields
                  formData={formData}
                  setFormData={setFormData}
                />
              )}

              {/* Lathe & Milling Machine Component Rendering */}
              {isLatheMachineSelected && (
                <AgencyLatheMachineFields
                  formData={formData}
                  setFormData={setFormData}
                />
              )}

              {/* Electrician-specific fields */}
              {isElectricianSelected && (
                <AgencyElectricianFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {/* Elevator Technician-specific fields */}
              {isElevatorTechnicianSelected && (
                <AgencyElevatorTechnicianFields
                  formData={formData}
                  updateField={updateField}
                />
              )}

              {isCncOperatorSelected && (
                <>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Position Applying For *</h4>
                    <Row className="g-3 text-left mt-2">
                      {cncOperatorPositions.map((opt, idx) => (
                        <Col xs={6} md={4} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.cnc_operator_position === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('cnc_operator_position', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Industry *</h4>
                    <Row className="g-3 text-left mt-2">
                      {cncOperatorIndustries.map((opt, idx) => {
                        const predefined = ["Manufacturing", "Automotive", "Oil & Gas", "Aerospace", "Metal Fabrication"];
                        const isOtherText = formData.industry_experience && !predefined.includes(formData.industry_experience);
                        const isSelected = opt === 'Other' ? isOtherText : formData.industry_experience === opt;

                        return (
                          <Col xs={6} md={4} key={idx}>
                            <Button
                              variant="light"
                              className={`language-btn jobtype-btn w-100 ${isSelected ? 'selected-button' : ''}`}
                              onClick={() => {
                                if (opt === 'Other') {
                                  if (!isOtherText) updateField('industry_experience', 'Other');
                                } else {
                                  updateField('industry_experience', opt);
                                }
                              }}
                            >
                              {opt}
                            </Button>
                          </Col>
                        );
                      })}
                    </Row>
                    {formData.industry_experience && !["Manufacturing", "Automotive", "Oil & Gas", "Aerospace", "Metal Fabrication"].includes(formData.industry_experience) && (
                      <div className="mt-3 text-left animate__animated animate__fadeIn">
                        <Form.Control
                          type="text"
                          placeholder="Other Industry Experience (Type here)"
                          className="professional-input"
                          value={formData.industry_experience === 'Other' ? '' : formData.industry_experience}
                          onChange={(e) => updateField('industry_experience', e.target.value)}
                          autoFocus
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-5 text-left">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Machine Knowledge</h4>
                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>CNC Controls</h5> */}
                    <MultiSelectDropdown
                      title="Select CNC Controls"
                      field="cnc_controls"
                      options={cncOperatorControlsList}
                      selectedValues={formData.cnc_controls || []}
                      onSelect={(field, val) => toggleCncControls(val)}
                    />
                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Machines Operated</h5> */}
                    <MultiSelectDropdown
                      title="Select CNC Machines"
                      field="machines_operated"
                      options={cncOperatorMachinesList}
                      selectedValues={formData.machines_operated || []}
                      onSelect={(field, val) => toggleMachinesOperated(val)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Technical Skills</h4>
                    <MultiSelectDropdown
                      title="Select Technical Skills"
                      field="technical_skills"
                      options={cncOperatorTechnicalSkills}
                      selectedValues={formData.technical_skills || []}
                      onSelect={(field, val) => toggleTechnicalSkills(val)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Software Knowledge (if any)</h4>
                    <MultiSelectDropdown
                      title="Select Software Knowledge"
                      field="software_knowledge"
                      options={cncOperatorSoftwareKnowledge}
                      selectedValues={formData.software_knowledge || []}
                      onSelect={(field, val) => toggleSoftwareKnowledge(val)}
                    />
                  </div>
                </>
              )}

              {isCncProgrammerSelected && (
                <>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Gulf / Europe Experience *</h4>
                    <Row className="g-3">
                      {yesNoOptions.map((opt, idx) => (
                        <Col xs={6} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.gulf_europe_experience === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('gulf_europe_experience', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    {formData.gulf_europe_experience === 'Yes' && (
                      <div className="mt-4 animate__animated animate__fadeIn">
                        <h5 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Select Countries (Max 3)</h5>
                        <MultiSelectDropdown
                          title="Select Countries"
                          field="gulf_europe_countries"
                          options={allWorldCountries}
                          selectedValues={formData.gulf_europe_countries || []}
                          onSelect={(field, val) => toggleGulfEuropeCountries(val)}
                          maxSelections={3}
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Industry Experience *</h4>
                    <Row className="g-3 text-left mt-2">
                      {["Manufacturing", "Oil & Gas", "Aerospace", "Automotive"].map((opt, idx) => (
                        <Col xs={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.industry_experience === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('industry_experience', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                    <div className="mt-3 text-left">
                      <Form.Control
                        type="text"
                        placeholder="Other Industry Experience (Type here)"
                        className="professional-input"
                        value={!["Manufacturing", "Oil & Gas", "Aerospace", "Automotive"].includes(formData.industry_experience) && formData.industry_experience ? formData.industry_experience : ''}
                        onChange={(e) => updateField('industry_experience', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="mb-5 text-left">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Machine & Control Knowledge</h4>
                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>CNC Controls</h5> */}
                    <MultiSelectDropdown
                      title="Select CNC Controls"
                      field="cnc_controls"
                      options={cncControlsList}
                      selectedValues={formData.cnc_controls || []}
                      onSelect={(field, val) => toggleCncControls(val)}
                    />
                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Machines</h5> */}
                    <MultiSelectDropdown
                      title="Select CNC Machines"
                      field="cnc_machines"
                      options={cncMachinesList}
                      selectedValues={formData.cnc_machines || []}
                      onSelect={(field, val) => toggleCncMachines(val)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Programming & Software Skills</h4>

                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Programming Type</h5> */}
                    <div className="mt-2 text-left">
                      <CustomDropdown
                        title="Select Programming Type"
                        field="programming_type"
                        options={programmingTypes}
                        selectedValue={formData.programming_type}
                        onSelect={updateField}
                        menuClassName="personalinfo-nationality-menu"
                      />
                    </div>

                    {/* <h5 className="mb-2 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>CAD/CAM Knowledge</h5> */}
                    <MultiSelectDropdown
                      title="Select CAD/CAM Software"
                      field="cad_cam_knowledge"
                      options={cadCamList}
                      selectedValues={formData.cad_cam_knowledge || []}
                      onSelect={(field, val) => toggleCadCamKnowledge(val)}
                    />

                    <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Can you read engineering drawings?</h5>
                    <Row className="g-3 text-left">
                      {yesNoOptions.map((opt, idx) => (
                        <Col xs={6} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.read_engineering_drawings === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('read_engineering_drawings', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>GD&T Knowledge</h5>
                    <Row className="g-3 text-left">
                      {gdtKnowledgeOptions.map((opt, idx) => (
                        <Col xs={4} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.gdt_knowledge === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('gdt_knowledge', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    <h5 className="mb-3 mt-4 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Tool Setting / Offsets</h5>
                    <Row className="g-3 text-left">
                      {yesNoOptions.map((opt, idx) => (
                        <Col xs={6} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.tool_setting_offsets === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('tool_setting_offsets', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="mb-5 text-left">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Job Skills Checklist</h4>
                    <MultiSelectDropdown
                      title="Select Skills"
                      field="job_skills_checklist"
                      options={jobSkillsList}
                      selectedValues={formData.job_skills_checklist || []}
                      onSelect={(field, val) => toggleJobSkillsChecklist(val)}
                    />

                    {(formData.job_skills_checklist && formData.job_skills_checklist.length > 0) && (
                      <div className="mt-3 p-3 text-start" style={{ backgroundColor: '#f8f9fa', borderRadius: '0px' }}>
                        <h6 className="mb-3">Selected Skills:</h6>
                        {jobSkillsList.map((skill, idx) => {
                          const isSelected = formData.job_skills_checklist.includes(skill);
                          return isSelected ? (
                            <div key={idx} className="d-flex align-items-center mb-2">
                              <i className="bi bi-check-circle-fill text-success me-2"></i>
                              <span>{skill}</span>
                            </div>
                          ) : null;
                        })}
                      </div>
                    )}
                  </div>
                </>
              )}

              {isMechanicSelected && (
                <>
                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Worked With</h4>
                    <Row className="g-3 text-left">
                      {mechanicWorkedWith.map((opt, idx) => (
                        <Col xs={6} md={4} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${(formData.worked_with || []).includes(opt) ? 'selected-button' : ''}`}
                            onClick={() => toggleMechanicWorkedWith(opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Previous Company Name</h4>
                    <div className="text-left">
                      <Form.Control
                        type="text"
                        placeholder="Type previous company name"
                        className="professional-input"
                        value={formData.previous_company_name || ''}
                        onChange={(e) => updateField('previous_company_name', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Skills</h4>
                    <MultiSelectDropdown
                      title="Select Skills"
                      field="mechanic_skills"
                      options={mechanicSkillsList}
                      selectedValues={formData.mechanic_skills || []}
                      onSelect={(field, val) => toggleMechanicSkills(val)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Vehicle Experience</h4>
                    <MultiSelectDropdown
                      title="Select Vehicles"
                      field="vehicle_experience"
                      options={mechanicVehicleExperienceList}
                      selectedValues={formData.vehicle_experience || []}
                      onSelect={(field, val) => toggleMechanicVehicleExperience(val)}
                    />
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Tools & Technical Knowledge</h4>

                    <div className="mb-4">
                      <h5 className="mb-3 fields-headingfont text-left" style={{ color: "black" }}>Diagnostic Scanner Use *</h5>
                      <Row className="g-3 text-left">
                        {yesNoOptions.map((opt, idx) => (
                          <Col xs={6} key={idx}>
                            <Button
                              variant="light"
                              className={`language-btn jobtype-btn w-100 ${formData.diagnostic_scanner_use === opt ? 'selected-button' : ''}`}
                              onClick={() => updateField('diagnostic_scanner_use', opt)}
                            >
                              {opt}
                            </Button>
                          </Col>
                        ))}
                      </Row>
                    </div>

                    <div className="mb-4">
                      <h5 className="mb-3 fields-headingfont text-left" style={{ color: "black" }}>Read Wiring Diagrams *</h5>
                      <Row className="g-3 text-left">
                        {yesNoOptions.map((opt, idx) => (
                          <Col xs={6} key={idx}>
                            <Button
                              variant="light"
                              className={`language-btn jobtype-btn w-100 ${formData.read_wiring_diagrams === opt ? 'selected-button' : ''}`}
                              onClick={() => updateField('read_wiring_diagrams', opt)}
                            >
                              {opt}
                            </Button>
                          </Col>
                        ))}
                      </Row>
                    </div>

                    <div className="mb-4">
                      <h5 className="mb-3 fields-headingfont text-left" style={{ color: "black" }}>Work Independently *</h5>
                      <Row className="g-3 text-left">
                        {yesNoOptions.map((opt, idx) => (
                          <Col xs={6} key={idx}>
                            <Button
                              variant="light"
                              className={`language-btn jobtype-btn w-100 ${formData.work_independently === opt ? 'selected-button' : ''}`}
                              onClick={() => updateField('work_independently', opt)}
                            >
                              {opt}
                            </Button>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>

                  <div className="mb-5">
                    <h4 className="mb-3 fields-headingfont" style={{ color: "black", textAlign: 'left' }}>Driving License *</h4>
                    <Row className="g-3 text-left">
                      {mechanicDrivingLicenseOptions.map((opt, idx) => (
                        <Col xs={6} md={3} key={idx}>
                          <Button
                            variant="light"
                            className={`language-btn jobtype-btn w-100 ${formData.mechanic_driving_license === opt ? 'selected-button' : ''}`}
                            onClick={() => updateField('mechanic_driving_license', opt)}
                          >
                            {opt}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              )}

              <div className="mb-2">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Are you banned in any country?*</h4>
                <Row className="g-3 mb-3">
                  <Col xs={6}>
                    <Button
                      className={`option-btn w-100 ${formData.is_ban === false || formData.is_ban === 0 ? 'selected-button' : ''}`}
                      onClick={() => updateField('is_ban', false)}
                    >
                      No
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      className={`option-btn w-100 ${formData.is_ban === true || formData.is_ban === 1 ? 'selected-button' : ''}`}
                      onClick={() => updateField('is_ban', true)}
                    >
                      Yes
                    </Button>
                  </Col>
                </Row>
                {(formData.is_ban === true || formData.is_ban === 1) && (
                  <>
                    <h4 className="section-subheading mb-3 fields-headingfont">Reason for ban</h4>
                    <Row className="g-3">
                      {banReasons.map((reason, idx) => (
                        <Col xs={12} sm={6} md={4} key={idx}>
                          <Button
                            className={`reason-btn w-100 ${formData.ban_reason === reason ? 'selected-button' : ''}`}
                            onClick={() => updateField('ban_reason', reason)}
                          >
                            {reason}
                          </Button>
                        </Col>
                      ))}
                    </Row>

                    <div className="mt-4">
                      <h4 className="section-subheading mb-3 fields-headingfont">Banned Country*</h4>
                      <Form.Control
                        type="text"
                        placeholder="Enter the country where you are banned"
                        className="professional-input"
                        value={formData.banned_country ?? ''}
                        onChange={(e) => updateField('banned_country', e.target.value)}
                        required
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="mb-3">
                <div className="d-flex align-items-center mb-1">
                  <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Job Type*</h4>
                  <FaEye
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowNote(!showNote)}
                    title="View job type note"
                  />
                </div>

                {showNote && (
                  <p className="text-muted large mb-3">
                    Follow labor laws. Part-time jobs are for permanent residents only.
                  </p>
                )}

                <Row className="g-3 mb-3">
                  {jobTypes.slice(0, 2).map((type, idx) => (
                    <Col xs={6} md={6} key={idx}>
                      <Button
                        className={`language-btn jobtype-btn w-100 ${formData.job_type === type ? "selected-button" : ""
                          }`}
                        onClick={() => updateField("job_type", type)}
                      >
                        {type}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {jobTypes.length > 2 && (
                  <div className="mb-3">
                    <CustomDropdown
                      title="Select other Job Type"
                      field="job_type_dropdown"
                      options={jobTypes.slice(2)}
                      selectedValue={formData.job_type && !jobTypes.slice(0, 2).includes(formData.job_type) ? formData.job_type : ""}
                      onSelect={(field, value) => {
                        updateField("job_type", value);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>
                )}
              </div>

              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Start Date*</h4>
                <div className="row g-2 align-items-center mb-3">
                  <div className="col-6">
                    <Button
                      className={`startdate-btn w-100 ${formData.preferred_start_date === 'Immediate' ? 'selected-button' : ''}`}
                      onClick={() => updateField('preferred_start_date', 'Immediate')}
                    >
                      Immediate
                    </Button>
                  </div>

                  <div className="col-6">
                    <DatePicker
                      selected={
                        formData.preferred_start_date && formData.preferred_start_date !== 'Immediate'
                          ? (formData.preferred_start_date instanceof Date
                            ? formData.preferred_start_date
                            : new Date(formData.preferred_start_date))
                          : null
                      }
                      onChange={(date) => {
                        updateField('preferred_start_date', date);
                      }}
                      className="date-picker-input-startdate w-125"
                      placeholderText="Select date"
                      minDate={new Date()}
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      yearDropdownItemNumber={15}
                      scrollableYearDropdown
                      dateFormat="MM/dd/yyyy"
                      autoFocus={false}
                      isClearable={true}
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Current Work Status</h4>

                <Row className="g-3 mb-3">
                  {["Finished contract", "Terminated (relocation / financial)", "Transfered", "Working in home country"].map((status, idx) => {
                    if (!workStatuses.includes(status)) return null;

                    return (
                      <Col xs={6} lg={3} key={idx}>
                        <Button
                          className={`language-btn status-btn w-100 ${formData.current_work_status === status ? 'selected-button' : ''}`}
                          onClick={() => updateField('current_work_status', status)}
                        >
                          {status === "Terminated (relocation / financial)" ? "Terminated" :
                            status === "Working in home country" ? "Relocation" : status}
                        </Button>
                      </Col>
                    );
                  })}
                </Row>

                <div className="mb-3">
                  <CustomDropdown
                    title="Select other work status"
                    field="current_work_status_dropdown"
                    options={workStatuses.filter(status =>
                      !["Finished contract", "Terminated (relocation / financial)", "Transfered", "Working in home country"].includes(status)
                    )}
                    selectedValue={formData.current_work_status &&
                      !["Finished contract", "Terminated (relocation / financial)", "Transfered", "Working in home country"].includes(formData.current_work_status)
                      ? formData.current_work_status : ""}
                    onSelect={(field, value) => {
                      updateField('current_work_status', value);
                    }}
                    required={false}
                    menuClassName="personalinfo-nationality-menu"
                  />
                </div>
              </div>

              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Which visa do you have?</h4>

                {/* First row buttons - Only these 4 options */}
                <Row className="g-3 mb-3">
                  {[
                    { label: "Looking for Visa", value: "Looking for visa" },
                    { label: "I have Work Visa", value: "I have Work Visa" },
                    { label: "Visit Visa", value: "Visit visa" },
                    { label: "Family Visa", value: "Family Visa" }
                  ].map((item, idx) => (
                    <Col xs={6} lg={3} key={idx}>
                      <Button
                        className={`language-btn visa-btn w-100 ${formData.visa_type === item.value ? 'selected-button' : ''}`}
                        onClick={() => updateField('visa_type', item.value)}
                      >
                        {item.label}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {/* Dropdown for remaining visa types */}
                <div className="mb-3">
                  <CustomDropdown
                    title="Select other visa type"
                    field="visa_type_dropdown"
                    options={visaTypes.filter(visa =>
                      !["Looking for visa", "I have Work Visa", "Visit visa", "Family Visa"].includes(visa)
                    )}
                    selectedValue={formData.visa_type &&
                      !["Looking for visa", "I have Work Visa", "Visit visa", "Family Visa"].includes(formData.visa_type)
                      ? formData.visa_type : ""}
                    onSelect={(field, value) => {
                      updateField('visa_type', value);
                    }}
                    required={false}
                    menuClassName="personalinfo-nationality-menu"
                    allowClear={true}
                  />
                </div>

                {formData.visa_type &&
                  !["no visa", "need visa", "need family visa", "looking for visa"].includes(formData.visa_type.toLowerCase()) && (
                    <Row className="g-3 mt-3">
                      <Col xs={6} md={6}>
                        <h2 className='fields-headingfont'>Issued Date</h2>
                        <DatePicker
                          ref={visaIssuedDateRef}
                          selected={formData.visa_issued_date}
                          onChange={(date) => updateField('visa_issued_date', date)}
                          className="date-picker-input-professionainfo"
                          placeholderText="Select issued date"
                          autoFocus={false}
                        />
                      </Col>
                      <Col xs={6} md={6}>
                        <h2 className='fields-headingfont'>Expiry Date</h2>
                        <DatePicker
                          selected={formData.visa_expiry_date}
                          onChange={(date) => updateField('visa_expiry_date', date)}
                          className="date-picker-input-professionainfo"
                          placeholderText="Select expiry date"
                          minDate={formData.visa_issued_date || new Date()}
                          autoFocus={false}
                        />
                      </Col>
                    </Row>
                  )}
              </div>

              {formData.visa_type === "Work visa" && (
                <div className="mb-5">
                  <h4 className="mb-3 fields-headingfont" style={{ color: "black" }}>Do you have NOC / Transfer letter?</h4>
                  <div className="d-flex flex-wrap gap-3">
                    <Button className={`option-btn ${formData.noc_or_transfer_letter === true ? 'selected-button' : ''}`} onClick={() => updateField('noc_or_transfer_letter', true)}>Yes</Button>
                    <Button className={`option-btn ${formData.noc_or_transfer_letter === false ? 'selected-button' : ''}`} onClick={() => updateField('noc_or_transfer_letter', false)}>No</Button>
                  </div>
                </div>
              )}

              <div className="additional-section mb-4" style={{ marginTop: '20px' }}>
                <div className="d-flex gap-2" style={{ width: "100%" }}>
                  <button
                    className="nav-btn"
                    style={{ flex: 1 }}
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  <button
                    className="nav-btn"
                    style={{ flex: 1 }}
                    onClick={handleNext}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Saving...' : 'Next'}
                  </button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default Professionalinfo;






